/* Global functions */

// Check for jQuery
function check_jQuery() {
    if ( ! window.jQuery ) {
        console.log( 'jQuery was not loaded!' );
    }
}

// --------------------

// FIX: Passive event listeners
// INFO: https://stackoverflow.com/questions/60357083/does-not-use-passive-listeners-to-improve-scrolling-performance-lighthouse-repo
function set_listener_fix() {
    // Double check for jQuery
    if ( window.jQuery ) {
        // Touchstart
        jQuery.event.special.touchstart = {
            setup: function (_, ns, handle) {
                this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
            }
        };
        // Touchmove
        jQuery.event.special.touchmove = {
            setup: function (_, ns, handle) {
                this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
            }
        };
        // Mousewheel
        jQuery.event.special.mousewheel = {
            setup: function (_, ns, handle) {
                this.addEventListener("mousewheel", handle, {passive: !ns.includes("noPreventDefault")});
            }
        };
    }

    // Fix: Mobile Safari - Enabling the :active CSS pseudo state
    document.addEventListener( 'touchstart', function() {}, false);
}

// --------------------

// Wait - deferred
function wait( ms ) {
    let deferred = jQuery.Deferred();

    setTimeout( function() {
        deferred.resolve()
    }, ms );

    return deferred.promise();

    // Sample usage
    // wait( 750 ).then( function() {
    //     wrapper.animate({
    //         scrollTop: y
    //     });
    // });
}

// ----------------------------

// Debounce function to prevent frequent executions
function debounce( func, delay ) {
    clearTimeout( function_timer );
    function_timer = setTimeout( func, delay );
}

// --------------------

// Go navigate
function go_navigate( event, url, bool, arg ) {
    let target = '';

    if ( event && typeof event !== 'undefined' ) {
        let key = 'which' in event ? event.which : event.keyCode;

        if ( key === 17 || event.ctrlKey || ( arg && typeof arg !== 'undefined' )) {
            target = '_blank';
        } else {
            target = '_self';
        }
    }

    if ( bool ) { window.open( url, target ); } else { window.location = url; }
}

// --------------------

// Loading animation
function loading( arg ) {
    let loading = jQuery( '#loading' );
    // if ( arg ) { mask.show(); loading.fadeIn( 10 ); } else { loading.hide(); mask.hide(); }
    // NOTE: Some people have epilepsi, showing mask should be optional due to flickering!
    // TODO: Discuss this item KW1
    if ( arg ) { loading.fadeIn( 10 ); } else { loading.hide(); }
}

// --------------------

// Mask layer
function mask_layer( arg ) {
    let mask = jQuery( '#mask' );
    if ( arg ) { mask.fadeIn( 10 ); } else { mask.hide(); }
}

// --------------------

// Body contains class: true / false
function body_class( arg ) {
    if ( jQuery( 'body[class*="' + arg + '"]' ).length > 0 ) { return true; } else { return false; }
}

// --------------------

// Element has classes: true / false
function has_class( elem, arg ) {
    if ( jQuery( elem + '[class*="' + arg + '"]' ).length > 0 ) { return true; } else { return false; }
}

// --------------------

// Detect touch device / screen
function check_touch() {
    let has_touch = ( 'ontouchstart' in document.documentElement );

    if ( has_touch ) {
        the_htm.addClass( 'touch' );
    } else {
        the_htm.addClass( 'no-touch' );
    }
}

// --------------------

// HTML Entities encode
function encodeEntities( str ) {
    if ( str && typeof str !== 'undefined' ) {
        return String( str ).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;').replace(/=/g, '&#61;').replace(/\//g, '&#47;');
    }
}

// HTML Entities decode
function decodeEntities( str ) {
    if ( str && typeof str !== 'undefined' ) {
        let textArea = document.createElement( 'textarea' );
        textArea.innerHTML = str;
        return textArea.value;
    }
}

// --------------------

// UcFirst
// Make it possible to have ucfirst function like in PHP
function ucfirst( str ) {
    str += '';
    let f = str.charAt( 0 ).toUpperCase();

    // Added extra illegal character filtering
    return f + str.substr( 1 ).replace( /[\/\\:;"*^~`\,\{\}\)\(\+=\'\?\!«»“”%\<\>#&\|\$€\[\]]+/g, '' );
}

// --------------------

// Case insensitive filter jQuery extend
jQuery.extend( jQuery.expr[ ':' ], {
    'contains': function( elem, i, match, array ) {
        return ( elem.textContent || elem.innerText || '' ).toLowerCase().indexOf(( match[3] || '' ).toLowerCase() ) >= 0;
    }}
);

// --------------------

// Get url parameters
// Strip out all parameters and make them available
// Usage => let id = getUrlParameter( 'products_id' );
let getUrlParameter = function getUrlParameter( sParam ) {
    let sPageURL = decodeURIComponent( window.location.search.substring( 1 ) ),
        sURLVariables = sPageURL.split( '&' ),
        sParameterName,
        i;

    for ( i = 0; i < sURLVariables.length; i++ ) {
        sParameterName = sURLVariables[i].split( '=' );

        if ( sParameterName[0] === sParam ) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

// --------------------

// Check if file exists
function file_exists( url ) {
    let http = new XMLHttpRequest();
    http.open( 'HEAD', url, false );
    http.send();
    return http.status != 404 ;
}

// --------------------

// Console logging
let debug = ( ref, bool, arg ) => {
    let bold  = 'font-weight: bold';

    if ( _debug && bool === true && typeof arg !== 'undefined' ) {
        return console.log( '%c' + ref + '%c' + ' * ' + arg, bold );
    }
}

// --------------------

// Check when scrolling ...
function set_scroll() {
    // Set scrolled class and show scroll button
    if ( document.body.scrollTop > scroll_trigger || document.documentElement.scrollTop > scroll_trigger ) {
        // Set scrolled class on target elements
        set_scrolled_class( true );
        // Show scroll to top element
        show_scroll_top( true );
    } else {
        set_scrolled_class( false );
        show_scroll_top( false );
    }
}

// Set scrolled class
function set_scrolled_class( bool ) {
    if ( bool === true ) {
        the_htm.addClass( 'scrolled' );
    } else {
        the_htm.removeClass( 'scrolled' );
    }
}

// INFO: https://www.w3schools.com/howto/howto_js_scroll_to_top.asp
// When the user scrolls down, show the button
function show_scroll_top( bool ) {
    let elem_scroll_top	= jQuery( '.js_scroll_top' );

    if ( bool === true ) {
        elem_scroll_top.show();
    } else {
        elem_scroll_top.hide();
    }
}

// Scroll to top
function scroll_to_top( arg, duration ) {
    if ( ! arg ) { arg = 0; } else { arg = jQuery( arg ).position().top; }
    if ( ! duration ) { duration = 250; }

    the_html_bod.animate({
        scrollTop: arg
    }, duration, 'swing' );
}

// --------------------

// Tooltip

// Prep. tooltip content
let prep_tooltip = function( arg ) {
    let tooltip_elem = jQuery( '#tooltip_cloud' );
    tooltip_elem.html( arg );
}

// Render tooltip
let render_tooltip = function( event, elem ) {
    // Some vars
    let _this				= elem;
    // let _this_pos           = Math.floor( _this.position() );
    let _this_width         = Math.floor( _this.outerWidth() );
    let _this_width_half    = Math.floor( _this_width / 2 );
    let _this_height        = Math.floor( _this.outerHeight() );
    // let _this_height_half   = Math.floor( _this_height / 2 );
    let doc_scroll_top		= Math.floor( the_doc.scrollTop() );
    let tooltip_elem		= jQuery( '#tooltip_cloud' );
    let tooltip_pos_left    = Math.floor( tooltip_elem.offset().left );
    // Viewport sizes
    let viewport_width = Math.max(
        the_win.innerWidth(),
        document.body.clientWidth
    );
    let viewport_height = Math.max(
        the_win.innerHeight(),
        document.body.clientHeight
    );
    let viewport_center_x	= Math.floor( viewport_width / 2 );
    let viewport_center_y	= Math.floor( viewport_height / 2 );
    // Tooltip sizes
    let tooltip_width		= Math.floor( tooltip_elem.outerWidth() );
    let tooltip_height		= Math.floor( tooltip_elem.outerHeight() );
    let tooltip_center_x	= Math.floor( tooltip_width / 2 );
    let tooltip_x_half      = tooltip_center_x;
    // let tooltip_x_diff      = tooltip_center_x - tooltip_width;
    // let tooltip_center_y	= Math.floor( tooltip_height / 2 );
    // let tooltip_y_half      = tooltip_center_y;
    // let tooltip_y_diff      = tooltip_center_y - tooltip_height;
    // Current pointer / default position
    let mouse_x             = Math.floor( event.clientX );
    let mouse_y             = Math.floor( event.clientY );
    // Calc prep.
    let calc                = 0;
    // CSS dump - Temporarily inject some CSS
    let css_dump            = jQuery( '#css_dump' );
    let css_dump_data       = '';
    // Clean CSS dump / classes
    css_dump.html( '' );
    // Set tooltip position
    tooltip_elem.css( 'left', (( _this.offset().left + _this_width_half ) - tooltip_x_half - 4 ) + 'px' );
    // TOP
    if (( mouse_y - doc_scroll_top ) < viewport_center_y ) {
        tooltip_elem.addClass( 'reversed' );
        tooltip_elem.css( 'top', ( _this.offset().top + ( _this_height + 8 )) + 'px' );
        // if ( mouse_y <= 20 ) {
        //     console.log( 'TOP COLLISION' );
        // } else {
        //     console.log( 'TOP' );
        // }
    }
    // BOTTOM
    if (( mouse_y - doc_scroll_top ) >= viewport_center_y ) {
        tooltip_elem.removeClass( 'reversed' );
        tooltip_elem.css( 'top', ( _this.offset().top - ( tooltip_height + 8 )) + 'px' );
        // if ( mouse_y >= ( viewport_height - 20 )) {
        //     console.log( 'BOTTOM COLLISION' );
        // } else {
        //     console.log( 'BOTTOM' );
        // }
    }
    // LEFT
    if ( mouse_x < viewport_center_x ) {
        if (( _this.offset().left + _this_width_half ) < tooltip_x_half ) {
            // console.log( 'LEFT COLLISION' );
            tooltip_elem.css( 'right', 'auto' );
            tooltip_elem.css( 'left', 0 + 'px' );
            calc = ( mouse_x - tooltip_pos_left ) + ( tooltip_x_half - 4 );
            css_dump_data = '#tooltip_cloud:after{margin-left:calc( -' + tooltip_width + 'px + ' + calc + 'px ) !important;}';
        } else {
            // console.log( 'LEFT' );
            tooltip_elem.css( 'left', (( _this.offset().left + _this_width_half ) - ( tooltip_x_half + 4 )) + 'px' );
        }
    }
    // RIGHT
    if ( mouse_x >= viewport_center_x ) {
        if (( _this.offset().left + _this_width_half + tooltip_x_half ) > viewport_width ) {
            // console.log( 'RIGHT COLLISION' );
            tooltip_elem.css( 'left', 'auto' );
            tooltip_elem.css( 'right', 0 + 'px' );
            calc = ( mouse_x - tooltip_pos_left ) + ( tooltip_x_half - 4 );
            css_dump_data = '#tooltip_cloud:after{margin-left:calc( -' + tooltip_width + 'px + ' + calc + 'px ) !important;}';
        } else {
            // console.log( 'RIGHT' );
            tooltip_elem.css( 'right', 'auto' );
            tooltip_elem.css( 'left', (( _this.offset().left + _this_width_half ) - ( tooltip_x_half + 4 )) + 'px' );
        }
    }
    // Correction for tooltip cloud size / follower
    if ( tooltip_width >= viewport_width ) {
        tooltip_elem.addClass('max');
        // LEFT
        if ( mouse_x < viewport_center_x ) {
            calc = ( mouse_x - tooltip_pos_left ) + ( tooltip_x_half + 30 );
        }
        // RIGHT
        if ( mouse_x >= viewport_center_x ) {
            calc = ( mouse_x - tooltip_pos_left ) + ( tooltip_x_half - 30 );
        }
        css_dump_data = '#tooltip_cloud:after{margin-left:calc( -' + tooltip_width + 'px + ' + calc + 'px ) !important;}';
    }
    // Wrap it up
    css_dump.html( css_dump_data );
    tooltip_cloud( 1 );
}

// Show / hide tooltip (cloud)
function tooltip_cloud( bool ) {
    if ( bool ) {
        jQuery( '#tooltip_cloud' ).addClass( 'active' );
    } else {
        jQuery( '#tooltip_cloud' ).removeClass( 'active' ).finish();
        jQuery( '#tooltip_cloud' ).html( '' );
    }
}

// --------------------

// Set slider
// INFO: https://kenwheeler.github.io/slick/#getting-started
// NOTE: Default values don't have to be specified again!
function set_slicked( tar ) {
    // If a target has been set ...
    if ( tar && typeof tar !== 'undefined' ) {
        jQuery( tar ).find( '.js_slicked' ).slick({
            // Default arguments here ...
            prevArrow: '<button class="slick-prev" type="button"></button>',
            nextArrow: '<button class="slick-next" type="button"></button>'
        });
        // Default behaviour ...
    } else {
        // Slider (trigger) found?
        jQuery.each(jQuery( '.js_slicked' ), function( index, value ) {
            let target_slider	= jQuery( this );
            let has_slider      = target_slider.length;
            let is_initialized  = target_slider.hasClass( 'slick-initialized' );
            if ( has_slider && typeof has_slider !== 'undefined' && ! is_initialized  ) {
                target_slider.slick({
                    // Default arguments here ...
                    prevArrow: '<button class="slick-prev" type="button"></button>',
                    nextArrow: '<button class="slick-next" type="button"></button>'
                });
            }
        });
    }
}

// Wreck slicked - Based on the target it will try to find the slick slider and completely remove all slick stuff
function wreck_slicked( tar ) {
    if ( tar && typeof tar !== 'undefined' ) {
        // Slider (trigger) found?
        let target_slider   = tar.find( '.js_slicked' );
        let has_slider      = target_slider.length;
        let is_initialized  = target_slider.hasClass( 'slick-initialized' );

        if ( has_slider && typeof has_slider !== 'undefined' && is_initialized  ) {
            // target_slider.slick( 'unslick' ).slick( 'reinit' );
            target_slider.slick( 'unslick' );
        }
    }
}

// Set no drag
// Removal of unnecessary SlickSlider lib drag event on child nodes
// NOTE: Increases RAM and browser performance after strongly reducing event listeners!
function set_no_drag() {
    let has_slick = jQuery( '.slick-slide' ).length;

    if ( has_slick && typeof has_slick !== 'undefined' ) {
        jQuery( '.slick-slide *' ).unbind( 'dragstart' );
    }
}

// --------------------

// Product details page: Tabs slick slider (re-)init fix
function go_tab_link( elem ) {
    let _this       = elem;
    let this_target = _this.attr( 'for' );
    let target_tab  = jQuery( '.tabs_wrapper .' + this_target );
    // console.log( this_target );
    // console.log( target_tab );
    wait( 100 ).then( function() {
        // wreck_slicked( target_tab );
        jQuery( wreck_slicked( target_tab )).promise().done( function() {
            set_slicked( target_tab );
        });
    });
}

// --------------------

// Set lazy load
// Load images according to viewport visibility
// INFO: http://jquery.eisbehr.de/lazy/
// Change img "src" to "data-src" / set preloader via library
function set_lazy_load() {
    let has_lazy    = jQuery( '.js_lazy' ).length;
    let debug_lazy  = false;

    if ( has_lazy && typeof has_lazy !== 'undefined' ) {
        jQuery( '.js_lazy' ).Lazy({
            // called before an elements gets handled
            beforeLoad: function( element ) {
                if ( debug_lazy ) {
                    let imageSrc = element.data( 'src' );
                    console.log( 'image "' + imageSrc + '" is about to be loaded' );
                }
            },
            // called after an element was successfully handled
            afterLoad: function( element ) {
                if ( debug_lazy ) {
                    let imageSrc = element.data( 'src' );
                    console.log( 'image "' + imageSrc + '" was loaded successfully' );
                }
            },
            // called whenever an element could not be handled
            onError: function( element ) {
                if ( debug_lazy ) {
                    let imageSrc = element.data( 'src' );
                    console.log( 'image "' + imageSrc + '" could not be loaded' );
                }
            },
            // called once all elements was handled
            onFinishedAll: function() {
                if ( debug_lazy ) {
                    console.log( 'finished loading all images' );
                }
            }
        });
    }
}

// ----------------------------

// History push state
// INFO: http://html5doctor.com/history-api/
// function history_push( url ) {
//	if ( url && typeof url !== 'undefined' ) {
//		// Add URL to history cache
//		push( url );
//	}
// }

// ----------------------------

// ----------------------------

// Set lightbox
// TODO: Find a way to trigger without using link elements!
function set_lightbox() {
    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true
    });
}

// ----------------------------

// Products listing view init + toggle
function set_list_view( arg, elem ) {
    let target_listing	= jQuery( '.product_listing_wrapper' );

    jQuery( '.js_list_view' ).removeClass( 'active' );

    if ( elem ) {
        elem.addClass( 'active' );
        arg = elem.attr( 'data-arg' );
    } else {
        jQuery( '.js_list_view[data-arg="' + arg + '"]' ).addClass( 'active' );
    }

    if ( arg === '1' ) {
        target_listing.removeClass( 'is_list' );
        do_stuff( '', '', '1', 'listing_view', '', '', 'general_settings' );
    }

    if ( arg === '2' ) {
        target_listing.addClass( 'is_list' );
        do_stuff( '', '', '2', 'listing_view', '', '', 'general_settings' );
    }
}

// ----------------------------

// Set languages (constants) dataset
// TODO: Migrate ALL JS texts to this ...
function set_lang_data_set() {
    let lang_params = {
        'ajax_action' : 'general_settings',
        'function' : 'load_language_texts'
    }

    jQuery.ajax({
        type: 'post',
        url: ajax_url_global + Math.random(),
        data: lang_params,
        dataType: 'json',
        async: true,
        success: function( data ) {
            // Get the lang_data_set data
            jQuery.each( data.lang_data_set, function( index, value ) {
                // Debug: Show all language key / value pairs
                // console.log( '' + index + ': ' + value );

                // Dump data into object
                // TODO: Migrate data sets to local storage objects?
                lang[index] = value;
            });
            // Debug
            // console.log( '\n\n' );
            // USAGE: Get specific text string based on key name
            //
            //    jQuery( SELECTOR ).html( text_js_overbook );   ---> becomes --->   jQuery( SELECTOR ).html( lang[ 'text_js_overbook' ] );
            //
            // console.log( lang[ 'text_js_overbook' ] );
            // console.log( '\n\n' );

            // console.log( data.lang_data_set );
        }
    });
}

// ----------------------------

// Form validation - Check fields
function check_fields( target, e ) {
    let _this           = target;
    // console.log( _this );
    const target_type   = _this.prop( 'tagName' ).toLowerCase();
    // console.log( target_type );
    const this_form     = ( target_type === 'form' ) ? _this : _this.closest( 'form' );
    let is_select2      = _this.is( '[class*="select2"]' );
    const is_check      = _this.attr( 'type' ) === 'checkbox' || _this.attr( 'type' ) === 'radio';
    const is_checked    = _this.prop( 'checked' ) === true || _this.is( ':checked' );
    const is_email      = _this.attr( 'type' ) === 'email';
    const email_val     = jQuery.trim( _this.val() );
    const reg           = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // Scroll numbers prep.
    let scroll_top            = 0;
    const pagetop             = typeof jQuery( '#pagetop' ) !== 'undefined' && jQuery( '#pagetop' ).length > 0 ? jQuery( '#pagetop' ).height() : 0;
    const pageheader          = typeof jQuery( '#pageheader' ) !== 'undefined' && jQuery( '#pageheader' ).length > 0 ? jQuery( '#pageheader' ).height() : 0;
    const navigation_wrapper  = typeof jQuery( '#navigation_wrapper' ) !== 'undefined' && jQuery( '#navigation_wrapper' ).length > 0 ? jQuery( '#navigation_wrapper' ).height() : 0;
    let scroll_offset         = Math.floor( pagetop + pageheader + navigation_wrapper + 20 );
    // Debug ...
    // console.log( 'Initial offset: ' + scroll_offset );
    let do_scroll       = false;
    // Errors counter prep.
    let has_errors      = 0;
    // Blocking handle prep.
    let block           = true;
    // Get / set form check attribute (fixes too much recursion)
    if ( _this.is( '[data-form_check]' )) {
        return;
    } else {
        _this.attr( 'data-form_check', 'checking' );
    }
    // Check based on target type
    if ( target_type === 'input' ) {
        // Checking ...
        if ( ! _this.val() ) {
            if ( is_select2 ) {
                _this.addClass( 'error_msg' );
                _this.closest( '.select' ).find( '.select2-container' ).addClass( 'error_msg' );
                // Set block
                block = true;
            } else {
                _this.addClass( 'error_msg' );
                // Set block
                block = true;
            }
        } else if ( _this.val() ) {
            if ( is_email && reg.test( email_val ) === false ) {
                _this.addClass( 'error_msg' );
                // Set block
                block = true;
                // NOTE: Since checkbox and radio always has a value, and thus returns "true" for this condition, we need to process this here
            } else if ( is_check && ! is_checked ) {
                _this.addClass( 'error_msg' );
                // Set block
                block = true;
            } else if ( is_check && is_checked ) {
                _this.removeClass( 'error_msg' );
            } else {
                if ( is_select2 ) {
                    _this.removeClass( 'error_msg' );
                    _this.closest( '.select' ).find( '.select2-container' ).removeClass( 'error_msg' );
                } else {
                    _this.removeClass( 'error_msg' );
                }
            }
        } else {
            // Remove block
            block = false;
        }
        // In closing ...
        e.preventDefault();
        _this.removeAttr( 'data-form_check' );
        return false;
    } else if ( target_type === 'form' ) {
        const fields = _this.find( '.js_required:visible' );
        const checks = _this.find( ':checkbox.js_required:visible, :radio.js_required:visible' );
        // Check each required input
        fields.each( function() {
            let this_field  = jQuery( this );
            is_select2  = this_field.is( '[class*="select2"]' );
            // Checking ...
            if ( ! this_field.val() ) {
                // Set error_msg class
                if ( is_select2 ) {
                    this_field.addClass( 'error_msg' );
                    this_field.closest( '.select' ).find( '.select2-container' ).addClass( 'error_msg' );
                } else {
                    this_field.addClass( 'error_msg' );
                }
                // Get first error_msg element
                let first_error = _this.find( '.error_msg:first-of-type:visible' );
                // Re-init the first error element scroll value in case of select2
                if ( first_error.is( '[class*="select2"]' ) === true ) {
                    let new_selector_id = first_error.attr( 'data-select2-id' );
                    let new_selector    = _this.find( 'select[data-select2-id="' + new_selector_id + '"]' );
                    scroll_top          = Math.floor( new_selector.offset().top - scroll_offset );
                    // Debug ...
                    // console.log( 'Scroll to select2 error' );
                } else if ( first_error.is( '[class*="select2"]' ) === false ) {
                    scroll_top = Math.floor( first_error.offset().top - scroll_offset );
                    // Debug ...
                    // console.log( 'Scroll to regular error' );
                }
                // Set block
                block = true;
                // Trigger scroll
                do_scroll = true;
            } else if ( this_field.val() ) {
                if ( is_select2 ) {
                    this_field.removeClass( 'error_msg' );
                    this_field.closest( '.select' ).find( '.select2-container' ).removeClass( 'error_msg' );
                } else {
                    this_field.removeClass( 'error_msg' );
                }
            } else {
                // Remove block
                block = false;
                // No scroll
                do_scroll = false;
            }
            // Debug ...
            // console.log( 'Validated offset: ' + scroll_offset );
            // console.log( 'scroll_top: ' + scroll_top );
        });
        let pass_radio_validation = false;
        // Check each checkbox / radio specifically
        checks.each( function() {
            let _that	= jQuery( this );
            let is_radio      = _that.attr( 'type' ) === 'radio';
            let radio_group      = (is_radio) ? _that.attr( 'name' ) : '';
            let that_id = _that.attr( 'id' );
            // Checking ...
            if ( _that.prop( 'checked' ) === false || ! _that.is( ':checked' )) {
                if((is_radio && !pass_radio_validation) || !is_radio){
                    _that.addClass( 'error_msg' );
                }

                // Set block
                block = true;
                // Trigger scroll
                do_scroll = true;
                // Show some message
                // Bitte bestätigen Sie, dass Sie die Datenschutzbestimmungen gelesen haben und diese akzeptieren.
                // Bitte bestätigen Sie, dass Sie die Allgemeinen Geschäftsbedingungen gelesen haben und diese akzeptieren.
                // Bitte bestätigen Sie, dass Sie das Widerrufsrecht gelesen haben und dieses akzeptieren.
                if ( that_id === 'privacy_conditions' ) {
                    // Swal.fire({
                    //     icon: 'warning',
                    //     title: GLOB_ATTENTION,
                    //     html: validation_checkbox,
                    //     showDenyButton: false,
                    //     confirmButtonText: BTN_CONTINUE,
                    //     showCloseButton: true,
                    //     // URL: https://stackoverflow.com/questions/52542982/sweetalert2-scrolls-to-initiating-element-after-close
                    //     // URL: https://stackoverflow.com/questions/52478592/how-to-animate-window-scrollto-with-javascript-not-jquery
                    //     didClose: () => window.scrollTo({top:(scroll_top+50),left:0,behavior:'smooth'})
                    // })
                    // --------------------
                    // NOTE: SweetAlert2 modal ruins the complete interaction, hence switched to modified toast ...
                    // Simple toast + custom options
                    toast_title     = GLOB_ATTENTION;
                    toast_content   = validation_checkbox;
                    toast_icon      = 'error';
                    do_toast( toast_title, toast_content, toast_icon, 600000, '', true, 'modal_clone', true, BTN_CONTINUE );
                    // Additionally, when all other fields are fine, set the scroll to this checkbox
                    let privacy_conditions  = _this.find( 'input[type="checkbox"]#privacy_conditions.error_msg:visible' );
                    let checkbox_offset     = Math.floor( privacy_conditions.offset().top - scroll_offset );
                    let all_other_fields    = this_form.find( 'input[type="text"].js_required.error_msg:visible, ' +
                        'input[type="email"].js_required.error_msg:visible, ' +
                        'input[type="textarea"].js_required.error_msg:visible, ' +
                        'input[type="select"].js_required.error_msg:visible, ' +
                        'input[type="radio"].js_required.error_msg:visible' );
                    if ( privacy_conditions.length === 1 && all_other_fields.length === 0 ) {
                        scroll_top = checkbox_offset;
                        // Debug ...
                        // console.log( 'Found privacy conditions error: ' + privacy_conditions.length );
                        // console.log( 'Found other field errors: ' + all_other_fields.length );
                        // console.log( 'Scroll to privacy conditions checkbox' );
                        // console.log( 'scroll_top: ' + scroll_top );
                    }
                }
            }else{
                _that.removeClass( 'error_msg' );
                if(is_radio){
                    // check radio group
                    jQuery( 'input[type="radio"][name="' +radio_group + '"]' ).removeClass( 'error_msg' );
                    pass_radio_validation = true;
                }
            }
        });
    }
    // Find all errors
    has_errors = this_form.find( '.js_required.error_msg:visible' ).length;
    // Extra re-check for blocking based on errors detected
    if ( typeof has_errors !== 'undefined' && has_errors > 0 ) {
        // Set block
        block = true;
    } else if ( typeof has_errors === 'undefined' || has_errors === 0 ) {
        // Remove block
        block = false;
    }

    if(target_type === 'form'){
        // Scroll if needed
        if ( do_scroll === true && block === true) {
            // Do some scrolling
            the_html_bod.animate({
                scrollTop: scroll_top
            }, 0, 'swing' );
        }
    }
    // Debug ...
    // console.log( 'Has errors: ' + has_errors );
    // console.log( 'Blocking: ' + block );
    // Allow / block submit
    if ( block === true ) {
        e.preventDefault();
        _this.removeAttr( 'data-form_check' );
        return false;
    } else if ( target_type === 'form' && block === false ) {
        _this.submit();
        _this.removeAttr( 'data-form_check' );
    }
}

// ----------------------------

// General deletion
function gen_delete( the_target, the_parent, the_id, the_pos_id, the_ref, the_arg ) {
    let func = '';

    // Switch arguments
    switch ( the_ref ) {
        case 'remove_shopping_list':
        case 'remove_shopping_list_item':

            if ( the_ref === 'remove_shopping_list' ) {
                jQuery.ajax({
                    type: 'POST',
                    url: ajax_url_global + Math.random(),
                    data: {
                        listID: the_id,
                        ajax_action: 'shopping_list',
                        function: 'delete_list'
                    },
                    async: true,
                    dataType: 'json',
                    success: function( data ) {
                        if ( the_id ) {
                            jQuery( '.watch_list_item[data-pos_id="' + the_id + '"]' ).remove();
                        }
                    },
                    complete: function() { },
                    error: function() {
                        console.log( 'Something went wong... Hai!' );
                    }
                });
            } else if ( the_ref === 'remove_shopping_list_item' ) {
                jQuery.ajax({
                    type: 'POST',
                    url: ajax_url_global + Math.random(),
                    data: {
                        productID: the_pos_id,
                        listID: the_id,
                        ajax_action: 'shopping_list',
                        function: 'delete_product'
                    },
                    async: true,
                    dataType: 'json',
                    success: function( data ) {
                        let watchlist_count		    = data.watchlist_count;
                        let watchlist_counter       = jQuery( '.watchlist_count' );
                        let edit_watchlist          = jQuery( '.js_edit_watch_list_name' );
                        let watchlist_notification  = jQuery( '.watchlist_notification' );

                        if ( the_pos_id ) {
                            jQuery( '.cart_container_line[data-pos_id="' + the_pos_id + '"]' ).remove();
                        }

                        // Found watch list items
                        if ( watchlist_count > 0 ) {
                            watchlist_counter.html( watchlist_count );
                            // console.log( 'watchlist active' );
                        } else {
                            watchlist_counter.html( 0 );
                            edit_watchlist.hide();
                            watchlist_notification.html( WATCHLIST_NOTIFICATION_EMPTY );
                            // console.log( 'watchlist disabled' );
                        }

                        close_message();
                        mask_layer( false );
                    },
                    complete: function() { },
                    error: function() {
                        console.log( 'Something went wong... Hai!' );
                    }
                });
            }
            break;
        case 'remove_notification':
            jQuery.ajax({
                type: 'POST',
                url: ajax_url_global + Math.random(),
                data: {
                    pid: the_id,
                    ajax_action: 'notification_center',
                    function: 'remove_notification'
                },
                async: true,
                dataType: 'json',
                success: function( data ) {
                    location.reload();
                },
                complete: function( data ) {
                },
                error: function() {
                    console.log('Something went wong... Hai!');
                }
            });
            break;
    }
}

// ----------------------------

// Prevent invalid input on native HTML5 input type = number fields as fallback
// INFO: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
function do_check_numeric( event ) {
    // Key bindings
    let key = 'which' in event ? event.which : event.keyCode;

    // Allow some special keys
    if ( key === 46 || key === 8 || key === 9 || key === 27 || key === 13 || ( key === 65 && event.ctrlKey === true ) || ( key >= 35 && key <= 39 ) ) {
        return;
    } else {
        // If it's not a number stop the keypress
        if ( event.shiftKey || ( key < 48 || key > 57 ) && ( key < 96 || key > 105 ) ) {
            event.preventDefault();
            return false;
        }
    }
}

// ----------------------------

// Set select2 dropdown
// INFO: https://select2.org/
function set_select2( ajax_search) {
    if ( ! ajax_search ) {
        ajax_search = 0;
    }
    let target_select   = jQuery( '.js_select' );
    let has_select      = target_select.length;

    if ( has_select && typeof has_select !== 'undefined' ) {
        // Batch of select2 dropdowns here

        // If details page unit type selection
        // if ( target_select.is( '.unit_type' )) {
            jQuery( 'select.unit_type' ).select2({
                width: 'resolve',
                minimumResultsForSearch: -1,
                dropdownAutoWidth: false
            }).on( 'change', function( e ) { // todo: change the toggle event when refactoring the cart fields/Product cell price
                let this_selected = jQuery( this ).find('option:selected');
                let this_unit_id = this_selected.data( 'unit_id' );
                let parent_wrapper = this_selected.parent().parent().parent();
                if(this_selected.data( 'is_list' )){
                    let this_pid = this_selected.data( 'pid' );
                    parent_wrapper = this_selected.parent().parent().parent().parent().find('td.td_price[data-pid="' + this_pid + '"]');
                }else{
                    jQuery( this ).closest( '.product_quantity' ).attr('data-min',this_selected.data( 'minimum' )).attr('min',this_selected.data( 'minimum' )).val(this_selected.data( 'minimum' ));

                }
                parent_wrapper.find('.product_price_unit_wrapper').addClass('hide_it');
                parent_wrapper.find('.product_price_unit_wrapper[data-unit-id="' + this_unit_id + '"]').removeClass('hide_it');
            });

    }

    jQuery( 'select.country_id' ).select2({
        width: 'resolve',
        minimumResultsForSearch: -1,
        dropdownAutoWidth: false
    }).on('change', function (e) {
        let this_selected   = jQuery( 'select.country_id option:selected' );
        let this_val        = this_selected.val();
        // Debug ...
        // console.log('country_id: ' + this_val);
        // Process data
        check_country_required(this_val);
    });

    jQuery( 'select.gender' ).select2({
        width: 'resolve',
        minimumResultsForSearch: -1,
        dropdownAutoWidth: false
    }).on('change', function (e) {
        let this_selected   = jQuery( 'select.gender option:selected' );
        let this_val        = this_selected.val();
        // Debug ...
        // console.log('gender: ' + this_val);
    });

    // Select2 form dropdown
    // TODO: Create a more dynamic and reliable solution - this is not clean coding.
    jQuery('.select select').select2({
        minimumResultsForSearch: Infinity,
        language: lang['languages_code']
    });

    // select2 Product Info
    jQuery('select.amount_product').each(function () {
        let this_id = jQuery(this).attr('name');

        jQuery(this).select2({
            minimumResultsForSearch: Infinity,
            language: lang['languages_code']
        }).on('change', function (e) {
            let data = jQuery('select.amount_product option:selected').val();
            let input = jQuery('#input_' + this_id);

            input.val(data);
        });
    });

    jQuery('.js_search_categories_filter select').select2({
            minimumResultsForSearch: Infinity,
            language: lang['languages_code'],
            dropdownCssClass: 'search_categories_filter_drop'
    }).on('select2:open', function (e) {
        jQuery('html').addClass('no_scroll');
    }).on('select2:close', function (e) {
        jQuery('html').removeClass('no_scroll');
    });

    jQuery('.select_attributes select').select2({
        minimumResultsForSearch: Infinity,
        language: lang['languages_code'],
        containerCssClass: 'attribute_options_container',
        dropdownCssClass: 'attribute_options_container',
        templateResult: formate_attributes,
        templateSelection: formate_attributes
    }).on('select2:select', function (e) {
        if(jQuery(e.params.data.element).hasClass( 'js_attribute_product_select' )){
            go_navigate('',jQuery(e.params.data.element).attr( 'data-product-ref' ));
        }
    });

    if(!ajax_search){
        // select2 Product Listing sort-order
        jQuery('.filter_on').select2({
            minimumResultsForSearch: Infinity,
            language: lang['languages_code'],
            width: '100%'
        }).on('change', function (e) {
            let data = jQuery('.filter_on option:selected').val();
            let target = jQuery('input[name="filter_on"]');

            target.val(data);
            populate_product_list('sorting_order', target.val());
        });

        // select2 Product Listing amount products
        jQuery('.filter_amount').select2({
            minimumResultsForSearch: Infinity,
            language: lang['languages_code']
        }).on('change', function (e) {
            let data = jQuery('.filter_amount option:selected').val();
            let target = jQuery('input[name="filter_amount"]');

            target.val(data);
            populate_product_list('listing_amount', target.val());
        });
    }
    // select2 Product filter (multiselect)
    jQuery( 'select.select_filter' ).select2({
        language: lang['languages_code'],
    }).on( 'change', function() {
        let _this	= jQuery( this );
        let cat_id	= _this.attr( 'data-catId' );
        let main_page	= _this.attr( 'data-page' );

        perform_ajax_filter_call( cat_id, 0 , main_page );
    }).on( 'select2:unselecting', function( evt ) {
        if ( ! evt.params.args.originalEvent ) {
            return;
        }

        evt.params.args.originalEvent.stopPropagation();
    });

    // select2 Variant dropdown - multiselect
    jQuery( 'select.select_variant' ).select2({
        language: lang['languages_code']
    }).on( 'change', function() {
        let selectContainer	= jQuery( jQuery( this ).parents( '.select_variant_container' ) ).find( 'select' );
        let ids				= '';
        let product			= jQuery( 'form[name="multiple_products_cart_quantity"] .js_variants tbody' ).children( 'tr.product-row' );
        let isVisible		= false;
        let isChange		= false;

        product.each( function( indexTR ) {
            isVisible = false;

            selectContainer.each( function( index ) {
                isChange	= false;
                ids			= ( jQuery(selectContainer[index] ).val() );

                if ( ids != null ) {
                    jQuery.each(ids, function (index) {
                        isChange = true;

                        jQuery( product[indexTR] ).children( 'td' ).each( function( indexTD ) {
                            if ( ids[index] == jQuery( jQuery( product[indexTR] ).children( 'td' )[indexTD] ).data( 'attribute_id' ) ) {
                                isVisible = true;
                                return false;
                            } else {
                                isVisible = false;
                            }
                        });

                        if ( isVisible == true ) {
                            return false;
                        }
                    });
                    if ( isVisible == false && isChange == true ) {
                        return false;
                    }
                }
            });

            if ( isVisible ) {
                jQuery( product[indexTR] ).show();
            } else {
                if ( isChange ) {
                    jQuery( product[indexTR] ).hide();
                } else {
                    jQuery( product[indexTR] ).show();
                }
            }
        });

        let selects = jQuery( 'select.select_variant' );
        let isRemoveFiltersVisible = false;

        if ( selects.length ) {
            selects.each( function( index ) {
                if ( jQuery( this ).val() != null ) {
                    isRemoveFiltersVisible = true;
                    return;
                }
            });
        }

        if ( isRemoveFiltersVisible ) {
            jQuery( '.js_remove_all_variant_filters' ).show();
        } else {
            jQuery( '.js_remove_all_variant_filters' ).hide();
        }
    });

    // select2 Objektleiter
    // TODO: Is this even working?
    jQuery( '.select_searchable' ).select2({
        language: lang['languages_code']
        //dropdownParent: jQuery('.select_searchable').parent().closest('div')
    });
}

// ----------------------------

// Details page unit type selection - Debug
// function get_unit_type_data( amount, id, stock ) {
//     let this_input      = jQuery( '.detail_page_product_cell.js_quantity_input' );
//     let this_dropdown	= jQuery( 'select.unit_type' );
//
//     let this_amount     = amount;
//     let this_unit_id	= id;
//     let this_stock		= stock;
//
//     console.log( 'this_amount: ' + this_amount );
//     console.log( 'this_unit_id: ' + this_unit_id );
//     console.log( 'this_stock: ' + this_stock );
// }

// ----------------------------
function formate_attributes(attribute, container){
    if (!attribute.id) {
        return attribute.text;
    }
    let optimage = jQuery(attribute.element).attr( 'data-img' );
    let optcolor = jQuery(attribute.element).attr( 'data-color' );
    let disabled_class = jQuery(attribute.element).attr( 'data-disabled-class' );
    if(disabled_class == 'unavailable'){
        jQuery(container).css({"opacity":0.6});
    }
    if(optcolor){
        jQuery(container).css({"background-color":optcolor});
        return attribute.text
    }else {
        if (!optimage) {
            return attribute.text
        } else {
            return jQuery(
                '<span><img src="' + optimage + '" class="attribute_img_dropdown" height="40" width="40"/> ' + attribute.text + '</span>'
            );
        }
    }
}
// ----------------------------

// Get listing filters - select2
function get_selected_select2_filter() {
    let selected_filters	= [];
    let att_id				= '';
    let att_value_id		= '';

    jQuery( '.select_filter' ).each( function( index ) {
        att_id = jQuery( this ).attr( 'data-attId' );

        jQuery( jQuery( this ).val() ).each( function() {
            selected_filters.push({
                'att_id': att_id,
                'att_value_id': '' + this
            });
        });
    });

    return selected_filters;
}

// Execute selected filter
function perform_ajax_filter_call( cat_id, regenerate_page, main_page ) {
    if(!regenerate_page){
        regenerate_page = 0;
    }
    let selected_filters = get_selected_select2_filter();
    let ajax_function = 'perform_filter';
    let searched_keywords = '';
    if(original_curr_page === 'advanced_search_result'){
        ajax_function = 'perform_filter_search';
        searched_keywords =  jQuery( '.js_searched_keywords' ).attr( 'data-keywords' );
        cat_id = jQuery('#main_listing').attr( 'data-catid');
    }
    jQuery.ajax({
        type: 'post',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_cat: cat_id,
            main_page: main_page,
            keywords: searched_keywords,
            ajax_selected_filters: JSON.stringify( selected_filters ),
            ajax_action: 'product_listing',
            function: ajax_function
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            populate_product_list_content( data.list );
            update_filter_list_content( data.filters, data.reset_block, data.used_filters, cat_id );
            change_url_state(data.list.new_url );
            if(ajax_function === 'perform_filter_search' && regenerate_page){
                jQuery('.js_category_sidebox_dynamic ').html(data.list.sidebox_cat_search);
                jQuery('#main_listing').attr( 'data-catid', data.list.category_id_search);
                //set_select2(1);
            }
        }
    });
}

function check_existing_filters(regenerate_page) {
    let cat_id = jQuery( '.ajax_product_listing' ).attr( 'data-catId' );
    let main_page = jQuery( '.ajax_product_listing' ).attr( 'data-page' );
    perform_ajax_filter_call( cat_id, regenerate_page, main_page );
}

// Populate article list content
function populate_product_list_content( data ) {
    jQuery( '.ajax_number_products_per_page' ).html( '' );
    jQuery( '.ajax_number_products_per_page' ).html( data.listing_count );
    jQuery( '.ajax_link_products_per_page' ).html( data.listing_links );
    jQuery( '.ajax_product_listing' ).html( '' );
    // Re-init slick slider (if needed)
    wait( 250 ).then( function() {
        jQuery( '.ajax_product_listing' ).html( data.div_content );
        jQuery( wreck_slicked( jQuery('.article_cell_listing' ))).promise().done( function() {
            jQuery(set_slicked()).promise().done( function() {
                ajax_load_list_prices_detailed( 'js_get_list_price_dynam' );
            });
        });
    });
}

// Update filter list content
function update_filter_list_content( filter_data, reset_block, used_filters, cat_id ) {
    jQuery( '.ajax_filter_reset_block' ).html( '' );
    jQuery( 'select.select_filter option' ).attr( 'disabled', 'disabled' );

    jQuery.each( filter_data, function(key,value ) {
        let res_att_id = value.att_id;

        jQuery.each( value.att_values, function( sub_key, sub_value ) {
            jQuery( 'select.select_filter[data-attID="' + res_att_id + '"] option[value="' + sub_value.att_val_id + '"]' ).attr( 'disabled', false );
        });
    });

    jQuery( '.ajax_filter_reset_block' ).html( reset_block );

    // TODO: To be refactored!
    // Hack: show button when there is a filter
    // if ( reset_block.length ) {
    //     jQuery( '.js_remove_all_filters' ).removeClass( 'hide' );
    // }
}

// Pagination
function populate_product_list( func, value, search_category_id ) {
    let cur_page		 	= jQuery( '.ajax_product_listing' ).attr( 'data-page' );
    let cur_cat_id		 	= jQuery( '.ajax_product_listing' ).attr( 'data-catId' );
    let selected_filters	= get_selected_select2_filter();
    let searched_keywords	= '';
    if ( ! search_category_id ) {
        search_category_id = 0;
    }
    // Hide tooltip
    tooltip_cloud();

    if ( func === 'listing_amount' || func === 'sorting_order' ) {
        if( cur_page === 'advanced_search_result'){
            func += '_search';
        }else{
            if(cur_page === 'specials'){
                jQuery( '.select_filter' ).val( '' );
            }else{
                jQuery( '.select_filter' ).val( '' ).change();
            }
            jQuery( '.ajax_filter_reset_block' ).html( '' );
        }
    }else{
        if( cur_page === 'advanced_search_result'){
            func = 'split_page_search';
        }
    }

    if(cur_page === 'advanced_search_result'){
        searched_keywords =  jQuery( '.js_searched_keywords' ).attr( 'data-keywords' );
        cur_cat_id = search_category_id;
        if(!search_category_id){
            cur_cat_id = jQuery( '#main_listing' ).attr( 'data-catid' );
        }else{
            func = 'split_page_search_category';
        }
    }

    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            val: value,
            keywords: searched_keywords,
            ajax_selected_filters: JSON.stringify( selected_filters ),
            main_page: cur_page,
            cat_id: cur_cat_id,
            ajax_action: 'product_listing',
            function: func
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            populate_product_list_content( data.list );
            if ( func === 'split_page' ||  func === 'split_page_search' ||  func === 'split_page_search_category' ) {
                let current_url = window.location.href;
                if(global_dev_mode === 'LOCAL' || cur_page === 'advanced_search_result'){
                    let new_url = current_url.split( '&page' ).shift();
                    window.history.pushState( {}, document.title, new_url  + '&page=' + value );
                }else{
                    let new_url = current_url.split( '?page' ).shift();
                    window.history.pushState( {}, document.title, new_url  + '?page=' + value );
                }

                if ( cur_page === 'index' || cur_page === 'specials' ) {
                    update_filter_list_content( data.filters, data.reset_block, data.used_filters, cur_cat_id );
                }
                if(cur_page === 'belege'){
                    loading( false );
                }
                if ( func === 'split_page_search_category') {
                    jQuery('#category_listing').remove();
                }
                if ( func === 'split_page_search' ||  func === 'split_page_search_category') {
                    jQuery('.js_category_sidebox_dynamic ').html(data.list.sidebox_cat_search);
                    if(selected_filters.length > 0 && func !== 'split_page_search_category'){
                        update_filter_list_content( data.filters, data.reset_block, data.used_filters, cur_cat_id );
                    }else{
                        jQuery('.js_search_filters_wrapper ').html(data.filter_search_element);
                    }
                    jQuery('#main_listing').attr( 'data-catid', data.list.category_id_search);
                    set_select2(1);
                }
            }
        },
        complete: function( data ) {
            jQuery( 'select.amount_product' ).each( function() {
                let this_id =  jQuery( this ).attr( 'name' );

                jQuery( this ).select2({
                    minimumResultsForSearch: Infinity,
                    language: lang['languages_code']
                }).on( 'change', function( e ) {
                    let data 	= jQuery( 'select.amount_product option:selected' ).val();
                    let input	= jQuery( '#input_' + this_id );
                    input.val( data );
                });
            });

            // Trigger lazy load images
            // set_lazy_load();
            // Re-init slick slider (if needed)
            wait( 250 ).then( function() {
                jQuery( wreck_slicked( jQuery('.article_cell_listing' ))).promise().done( function() {
                    set_slicked();
                });
            });
            // Scroll to top
            if(cur_page !== 'advanced_search_result'){
                scroll_to_top( '.listing_actions' );
            }
        },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

function reset_search_categories(){
    go_navigate( '',adv_search_url + jQuery( '.js_searched_keywords' ).attr( 'data-keywords' ) );
}
// ----------------------------

// Load detailed prices per ajax
function ajax_load_list_prices_detailed( ajax_class ) {
    let processed_id = [];
    jQuery( '.' + ajax_class ).each( function() {
        let _this			= jQuery( this );
        let p_id			= _this.attr( 'data-ajax-product-id' );
        if(jQuery.inArray(p_id,processed_id) == -1){
            let c_id			= _this.attr( 'data-ajax-category-id' );
            let has_no_stock	= _this.attr( 'data-ajax-product-has-no-stock' );
            let is_cross_sell	= _this.attr( 'data-ajax-cross-sell' );
            let product_qty	    = _this.attr( 'data-ajax-product-qty' );
            let show_cart		= _this.attr( 'data-ajax-show-cart' );
            let is_variant		= _this.attr( 'data-ajax-is-variant' );
            let is_configurable		= _this.attr( 'data-ajax-is-configurable' );
            let stock_info      = jQuery( '.js_stock_list[data-id="' + p_id + '"]' );

            jQuery.ajax({
                // cache: false,
                type: 'POST',
                url: ajax_url_global + Math.random(),
                data: {
                    data_id: p_id,
                    cat_id: c_id,
                    cart_flag: show_cart,
                    qty: product_qty,
                    stock_flag: has_no_stock,
                    variant_flag: is_variant,
                    configurable_flag: is_configurable,
                    cross_sell: is_cross_sell,
                    ajax_action: 'prices',
                    function: 'get_list_price_advanced'
                },
                async: true,
                dataType: 'json',
                success: function( response ) {
                    $micro_data = _this.html();
                    _this.html( response.products_price_html + $micro_data );
                    stock_info.html( response.products_pic_to_qty );
                    _this.after( response.products_input_field );
                },
                complete: function() { },
                error: function() {
                    console.log( 'Something went wong... hai!' );
                }

            });
        }
    });
}

// ----------------------------

// Do product / cart stuff - the function of all functions...
// TODO: Get rid of this garbage!
// TODO: Split events that trigger this into new functions!
function do_stuff( id, pos_id, qty, func, arg, trigger, act, additional_param, unit_id ) {
    // Debug
    // console.log( id + ' | ' + pos_id + ' | ' + qty + ' | ' + func + ' | ' + arg + ' | ' + trigger + ' | ' + act );

    // Cart
    let has_cart_contents		 	= jQuery( '.js_cart_default' ).is( ':visible' );
    let cart_contents			 	= jQuery( '.js_cart_default' );
    let cart_footer				 	= jQuery( '.js_cart_footer' );
    // Preview box
    let has_cart_preview			= jQuery( '.cartinfo_preview' ).is( ':visible' );
    let cart_preview				= jQuery( '.cartinfo_preview' );
    let cart_preview_contents 		= jQuery( '.cartinfo_preview_content' );
    let cart_preview_amount 		= jQuery( '.cartinfo_part_icon_amount, #cartinfo_part_icon_amount' );
    let cart_preview_price			= jQuery( '.cartinfo_part_price, #cartinfo_part_price' );
    let cartinfo_tooltip			= jQuery( '.cartinfo_part_icon_cart' );
    let the_input					= jQuery( 'input[data-id="' + id + '"]' );

    // Set data
    let source;
    let title;
    let mssg;

    // Close message box first
    close_message();

    if ( ! additional_param ) {
        additional_param = 0;
    }
    if ( ! unit_id ) {
        unit_id = 0;
    }

    // Set id to pos_id by default when it hasn't been set by function
    if ( ! func ) {
        func = 'add_product';
    }

    // Set action to by default when it hasn't been set by function
    if ( ! act ) {
        act = 'shopping_cart';
    }

    // Set id to pos_id by default when it hasn't been set by function
    if ( ! id ) {
        id = pos_id;
    }

    // Set pos_id to "0" by default when it hasn't been set by function
    if ( ! pos_id ) {
        pos_id = 0;
    }

    // Set quantity to "1" by default when it hasn't been set by function
    if ( ! qty ) {
        qty = 1;
    }

    // Fade out preview box first when visible
    if ( has_cart_preview ) {
        cart_preview.hide();
    }

    // Hide tooltip
    tooltip_cloud();

    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            product_id: id,
            product_einheit: unit_id,
            pos_id: pos_id,
            quantity: qty,
            ajax_action: act,
            overbook: additional_param,
            function: func
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            // Set output variables
            let total_items			= data.total_items;
            let total_products		= data.total_products;
            let total_weight;

            if ( data.products_total_weight ) {
                total_weight		= data.products_total_weight;
            } else {
                total_weight = 0;
            }

            let total_bruto			= data.total_brutto;
            let new_limit			= data.new_limit;
            let was_id				= data.was_id;
            let response_code		= data.response_code;
            let response_message	= data.response_message;
            let got_discount		= data.has_discount;

            // Check first if there was an ID? Trigger for deleting items from the cart list.
            if ( was_id ) {
                the_input = jQuery( 'input[data-id="' + was_id + '"]' );
            }

            // Set new limit for qty input
            the_input.attr( 'data-limit', new_limit );

            // Fill data
            source = data;

            // Update the preview box
            function update_preview() {
                // Populate the preview contents
                if ( total_items != 0 ) {
                    cart_preview_amount.html( total_items );
                    cartinfo_tooltip.attr( 'data-tooltip', amount_item_lang + ': ' + total_products );
                }

                cart_preview_price.html( data.total_display_price );
            }

            // Update the cart page
            function update_cart() {
                // Set content elements
                let content	= '';
                let footer	= '';

                // Gather element contents
                jQuery.each( data.products, function( object ) {
                    content += this.products_cart_line;
                });

                footer += '<div class="order_totals_payment ">' +
                    '<div class="payment_title title_total_products">' + total_item_lang + ':</div><div class="js_cart_amount payment_price price_total_products">' + total_products + '</div>' +
                    '<div class="payment_title title_total_weight">' + txt_total_weight + ':</div><div class="js_cart_weight payment_price price_total_products">' + total_weight + '&nbsp;' + product_unit + '</div>' +
                    '<div class="payment_title title_total_price">' + txt_total_sum + ':</div><div class="js_cart_price payment_price price_total_products">' + total_bruto + '</div>' +
                    '</div>';

                // Populate the cart contents
                cart_contents.html( content );
                // console.log( typeof (content ) );
                cart_contents.css( 'display', 'grid' );
                cartinfo_tooltip.attr( 'data-tooltip', amount_item_lang + ': ' + total_products );
                // Populate the cart footer contents
                cart_footer.html( footer );
            }

            // Switch arguments
            switch ( arg ) {
                case 'init':
                    if ( response_code == 100 ) {
                        title = GLOB_ATTENTION;
                        mssg = text_stock_limit;

                        message( 'warning', title, mssg, 'close_message(); mask_layer( false )', '', true );

                    } else if ( response_code == 200 ) {
                        title = GLOB_ATTENTION;
                        mssg = response_message;

                        message( 'warning', title, mssg, 'do_stuff( ' + was_id + ', \'\', ' + qty + ', \'add_product\', \'add\', \'' + trigger + '\', \'\', 1 )', 'close_message(); do_stuff( \'\', \'\', \'\', \'\', \'init_both\' ); mask_layer( false )', false );
                    } else if ( response_code > 299 ) {
                        title = GLOB_ATTENTION;
                        mssg = response_message;

                        message( 'warning', title, mssg, 'close_message(); mask_layer( false )', '', true );
                    }
                    // Update
                    update_preview();
                    update_cart();
                    break;

                case 'init_both':
                    if ( response_code == 100 ) {
                        title	= GLOB_ATTENTION;
                        mssg	= text_stock_limit;

                        message( 'warning', title, mssg, 'close_message(); mask_layer( false )', '', true );
                    } else if ( response_code == 200 ) {
                        title	= GLOB_ATTENTION;
                        mssg	= response_message;

                        if ( trigger == 'from_blur' ) {
                            message( 'warning', title, mssg, 'do_stuff( ' + was_id + ', \'\', ' + qty + ', \'update_product\', \'add\', \'' + trigger + '\', \'\', 1 )', 'close_message(); do_stuff( \'\', \'\', \'\', \'\', \'init_both\' ); mask_layer( false )', false );
                        } else {
                            message( 'warning', title, mssg, 'do_stuff( ' + was_id + ', \'\', ' + qty + ', \'add_product\', \'add\', \'' + trigger + '\', \'\', 1 )', 'close_message(); do_stuff( \'\', \'\', \'\', \'\', \'init_both\' ); mask_layer( false )', false );
                        }
                    } else if ( response_code > 299 ) {
                        title	= GLOB_ATTENTION;
                        mssg	= response_message;

                        message( 'warning', title, mssg, 'close_message(); mask_layer( false )', '', true );
                    }

                    // Update
                    update_preview();
                    update_cart();
                    break;

                case 'add':
                    if ( response_code == 100 ) {
                        title	= GLOB_ATTENTION;
                        mssg	= text_stock_limit;

                        message( 'warning', title, mssg, 'close_message(); mask_layer( false )', '', true );
                    } else if ( response_code == 200 ) {
                        title	= GLOB_ATTENTION;
                        mssg	= response_message;

                        message( 'warning', title, mssg, 'do_stuff( ' + was_id + ', \'\', ' + qty + ', \'add_product\', \'add\', \'' + trigger + '\', \'\', 1 )', 'close_message(); do_stuff( \'\', \'\', \'\', \'\', \'init_both\' ); mask_layer( false )', false );
                    } else if ( response_code > 299 ) {
                        title = GLOB_ATTENTION;
                        mssg = response_message;

                        message('warning', title, mssg, 'close_message(); mask_layer( false )', '', true);
                    }

                    // Update
                    update_preview();
                    update_cart();
                    break;
            }
        },
        complete: function( data ) {
            let total_items = data.total_items;

            switch( arg ) {
                case 'init_both':
                    jQuery( '.cart_heading_img .fix img' ).each( function() {
                        let _this		= jQuery( this );
                        _this.height	= '80%';
                        _this.width		= 'auto';
                    });
                    break;
            }

            let has_message = jQuery( '#message' ).is( ':visible' );

            if ( has_message ) {
                // Hide mask
                mask_layer( true );
            } else {
                // Hide mask
                mask_layer( false );
            }
        },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

// NEW FUNCTION!
// Process cart based on amount changes
// TODO: Migrate step-by-step ...
// TODO: Use js_ classes!
function do_process_cart( id, pos_id, qty, func, trigger, act, additional_param, unit_id , is_configurable, configurable_selection, configurable_pos_id) {
    // Debug
    // console.log( id + ' | ' + pos_id + ' | ' + qty + ' | ' + func + ' | ' + trigger + ' | ' + act + ' | ' + additional_param + ' | ' + unit_id );

    // TODO: Can we do the checking on the PHP side??
    // Set id to pos_id by default when it hasn't been set by function
    if ( ! id ) {
        id = pos_id;
    }
    // Set pos_id to "0" by default when it hasn't been set by function
    if ( ! pos_id ) {
        pos_id = 0;
    }

    if ( ! configurable_pos_id ) {
        configurable_pos_id = -1;
    }

    if ( ! is_configurable ) {
        is_configurable = 0;
    }

    if ( ! configurable_selection ) {
        configurable_selection = [];
    }

    // Set quantity to "1" by default when it hasn't been set by function
    if ( ! qty ) {
        qty = 1;
    }
    // Set id to pos_id by default when it hasn't been set by function
    if ( ! func ) {
        func = 'add_product';
    }
    // Set action to by default when it hasn't been set by function
    if ( ! act ) {
        act = 'shopping_cart';
    }
    // Any additional parameters?
    // TODO: If this is only overbook, make it a simple overbook boolean
    if ( ! additional_param ) {
        additional_param = 0;
    }
    // Unit ID???
    // TODO: What is this for?
    if ( ! unit_id ) {
        unit_id = 0;
    }

    // TODO: Migrate to Fetch, try / catch
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            product_id: id,
            current_page: original_curr_page,
            product_einheit: unit_id,
            pos_id: pos_id,
            configurable_pos_id: configurable_pos_id,
            configurable: is_configurable,
            configurable_data: configurable_selection,
            quantity: qty,
            ajax_action: act,
            overbook: additional_param,
            function: func
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            let new_limit			= data.new_limit;
            let response_code		= data.response_code;
            let response_message	= data.response_message;
            let got_discount		= data.has_discount;
            let cart_content        = '';
            // Set output variables
            // let cart_amount		= data.total_items;
            let cart_amount			= data.total_products;
            let cart_brut			= data.total_brutto;
            let cart_weight         = data.products_total_weight;

            // TODO: If cart weight is 0, don't show this line at all
            if ( ! cart_weight > 0 ) {
                // Kill it with fire!
            }

            jQuery.each( data.products, function( object ) {
                // TODO: Load TPL here and fill target elements OR send object to split function
                cart_content += this.products_cart_line;
            });

            // Stock reached
            if ( response_code > 0 ) {
                if ( response_code == 100 ) {
                    console.log( '100: ' + response_message );
                    // Overbook
                } else if ( response_code == 200 ) {
                    console.log( '200: ' + response_message );
                    // Everything else
                } else if ( response_code > 299 ) {
                    console.log( '> 299: ' + response_message );
                }
            }

            if ( got_discount ) {
                console.log( got_discount );
            }

            // TODO: Expand for checkout pages footer ...
            if ( body_class( 'is_cart' ) && cart_amount ) {
                // Update cart stats (header / footer)
                update_cart( cart_content, cart_amount, cart_weight, cart_brut );
            } else {
                update_cart( cart_content, cart_amount, cart_weight, cart_brut );
            }
        },
        complete: function( data ) { },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

// Update the cart stats
function update_cart( cart_content, cart_amount, cart_weight, cart_price ) {
    let empty_cart		    = jQuery( '.js_empty_cart' );
    let set_cart_content	= jQuery( '.js_cart_default' );
    let cart_footer		    = jQuery( '.js_cart_footer' );
    let notice_container    = jQuery( '.js_tax_notice_container' );
    let cart_button		    = jQuery( '.js_cart_button' );
    let set_cart_weight		= jQuery( '.js_cart_weight' );
    let set_cart_amount		= jQuery( '.js_cart_amount' );
    let set_cart_price		= jQuery( '.js_cart_price' );

    // Load template(s)?
    // jQuery( 'SELECTOR' ).load( 'FILENAME' );

    if ( body_class( 'is_cart' ) && cart_amount ) {
        // Fill content with data
        set_cart_content.html(cart_content);
        set_cart_weight.html(cart_weight + '&nbsp;' + product_unit);
        set_cart_amount.html(cart_amount);
        set_cart_price.html(cart_price);

        empty_cart.show();
        set_cart_content.css( 'display', 'grid' );
        cart_footer.show();
        notice_container.show();
        cart_button.show();
    } else if ( body_class( 'is_cart' ) && ! cart_amount ) {
        empty_cart.hide();
        set_cart_content.css( 'display', 'none' );
        cart_footer.hide();
        notice_container.hide();
        cart_button.hide();

        set_cart_amount.html( cart_amount );
        set_cart_price.html( cart_price );
    } else {
        if ( cart_amount ) {
            // Fill content with data
            set_cart_content.html(cart_content);
            set_cart_weight.html(cart_weight + '&nbsp;' + product_unit);
            cart_footer.show();
        }
        set_cart_amount.html(cart_amount);
        set_cart_price.html(cart_price);
    }
}

// Empty cart
function empty_cart() {
    let has_upload = jQuery( '.js_upload_container' ).length;

    Swal.fire({
        icon: 'warning',
        title: GLOB_WARNING,
        html: text_empty_cart,
        showDenyButton: true,
        confirmButtonText: BTN_CONTINUE,
        denyButtonText: BTN_CANCEL,
        showCloseButton: true
    }).then((result) => {
        if ( result.isConfirmed ) {
            do_process_cart( '', '', '', 'delete_all' );

            if ( has_upload && typeof has_upload !== 'undefined' ) {
                // let target_container    = jQuery( '[class*="js_upload_container"]' );
                let target_input_txt    = jQuery( '[class*="js_upload_text"]' );
                // Set default text for upload input
                target_input_txt.html( PH_SELECT_FILE );
            }
        }
    })
}

// ----------------------------

function availability_notification( event, elem ) {
    let _this       = elem;
    let this_id     = _this.data( 'id' );
    let this_type   = _this.data( 'type' );
    let this_login   = _this.data( 'login' );
    if(this_login){
        Swal.fire({
            icon: 'info',
            title: STOCK_NOTIFICATION_MESSAGE,
            html: STOCK_NOTIFICATION_MESSAGE_PRIVACY_NO_OPTIN,
            showDenyButton: true,
            denyButtonText: BTN_CANCEL,
            showCloseButton: true
        }).then(( result)  => {
            if ( result.isConfirmed ) {
                save_availability_notification(this_id, this_type, js_email_address, _this);
            }
        });
    }else{
        const { value: accept } = Swal.fire({
            icon: 'info',
            title: STOCK_NOTIFICATION_MESSAGE,
            input: 'email',
            inputValue: js_email_address,
            html: STOCK_NOTIFICATION_MESSAGE_PRIVACY,
            inputPlaceholder: ENTRY_EMAIL_ADDRESS,
            showDenyButton: true,
            denyButtonText: BTN_CANCEL,
            inputValidator: (result) => {
                return !result && ENTRY_EMAIL_ADDRESS_ERROR;
            },
            showCloseButton: true
        }).then(( accept)  => {
            if (accept.value) {
                const result = accept.value;
                save_availability_notification(this_id,this_type, result, _this);
            }
        });
    }
}

// ----------------------------

function save_availability_notification(this_id, this_type, result, elem){
    jQuery.ajax({
        type: 'post',
        url: ajax_url_global + Math.random(),
        data: {
            pid: this_id,
            type: this_type,
            email: result,
            ajax_action: 'notification_center',
            function: 'stock_notification'
        },
        dataType: 'json',
        async: true,
        success: function(data) {
            // Show unavailable toast
            toast_title     = GLOB_SUCCESS;
            toast_content   = data.success_message;
            toast_icon      = 'success';
            do_toast( toast_title, toast_content, toast_icon, 3000, '', true );
            elem.parent().after(data.new_button);
            elem.parent().remove();
        }
    });
}
// ----------------------------

// Add item to cart
// TODO: Add language constants for JS!
function add_to_cart( event, elem ) {
    let src_input           = elem.closest( '.product_quantity' ).find( '.js_quantity_input' );
    let this_amount         = Number( src_input.val() );
    let this_min            = Number( src_input.data( 'min' ));
    let this_max            = Number( src_input.data( 'max' ));
    let this_id             = src_input.data( 'prod_id' );
    let this_pos_id         = src_input.data( 'pos_id' );
    let this_prod_name      = src_input.data( 'prod_name' );
    let this_stock          = Number( src_input.attr( 'data-stock' ));
    let has_unit_id         = src_input.data( 'has_unit_ids' );
    let is_configurable         = Number(src_input.data( 'is_configurable' ));
    let configurable_selection        = [];
    let this_unit_entity    = src_input.data( 'unit_entity' );
    let this_unit_size      = Number( src_input.data( 'unit_size' )); // VPE?
    let overbook            = src_input.data( 'overbook' );
    let overbook_option     = 0;
    let amount_init         = this_amount;
    let amount_toast        = this_amount;
    // Backorder
    let backorder_amount    = this_amount - this_stock;
    let selected_option      = '';
    // Toast
    let toast_title         = '';
    let new_title           = '';
    let toast_content       = '';
    let new_content         = '';
    let toast_icon          = '';
    let arg                 = '';
    let used_unit_id = 0;
    let new_stock = 0;
    let selected_factor = 1;

    let task = 'add_product';

    if ( has_unit_id ) {
        let selected_id = elem.closest( '.product_quantity' ).find( 'select option:selected' ).data( 'unit_id' );
        let new_stock = elem.closest( '.product_quantity' ).find( 'select option:selected' ).attr( 'data-stock' );
        this_unit_entity = elem.closest( '.product_quantity' ).find( 'select option:selected' ).val();
        used_unit_id = selected_id;
        this_stock = Number(new_stock);
    }else{
        used_unit_id = src_input.data( 'used_unit_id' );
    }
    let configurable_pos_id = -1;
    if ( body_class( 'is_cart' ) ) {
        configurable_pos_id         = src_input.data( 'pos_id' );
    }
    if ( body_class( 'is_cart' ) ) {
        task = 'update_product';
    }else if(body_class( 'is_detail' ) && is_configurable){
        if(!validate_configurable_set()){
            return false;
        }
        jQuery('.js_select_component_amount ').each(function() {
            configurable_selection.push({
                code	: jQuery(this).data( 'component-code' ),
                product_id	: jQuery(this).data( 'component-product-id' ),
                quantity	: jQuery(this).val()
            });
        });
    }

    // Debug
    // console.log( 'this_id: value = ' + this_id + ' Type = ' + typeof( this_id ) + '\n' );
    // console.log( '---' + '\n' );
    // console.log( 'this_amount: value = ' + this_amount + ' Type = ' + typeof( this_amount ) + '\n' );
    // console.log( 'this_min: value = ' + this_min + ' Type = ' + typeof( this_min ) + '\n' );
    // console.log( 'this_max: value = ' + this_max + ' Type = ' + typeof( this_max ) + '\n' );
    // console.log( 'this_stock: value = ' + this_stock + ' Type = ' + typeof( this_stock ) + '\n' );
    // console.log( 'this_unit_size: value = ' + this_unit_size + ' Type = ' + typeof( this_unit_size ) + '\n' );
    // console.log( 'overbook: value = ' + overbook + ' Type = ' + typeof( overbook ) + '\n' );
    // console.log( '---------------------------------------------------------------------------------------------' + '\n\n' );

    // If the amount equals or doesn't cross any stock and max order (limit) value
    // if ( this_amount <= this_stock && this_amount <= this_max && this_amount > 0 ) {
    if ( this_amount <= this_stock && this_amount > 0 ) {
        // Show add to cart toast
        toast_title     = GLOB_SUCCESS;
        if(task === 'update_product'){
            if(this_amount < this_min){
                this_amount = this_min;
            }
            toast_content   = '<li>' + CART_ARTICLE_UPDATED_AMOUNT + ' <b>' +  this_prod_name + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_TO + ' <b>' + this_amount + ' ' + this_unit_entity + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_CHANGED;
        }else{
            toast_content   = '<li><b>' + this_amount + ' ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> ' + CART_ARTICLE_ADDED;
        }

        toast_icon      = 'success';

        jQuery( do_toast( toast_title, toast_content, toast_icon, 3000, arg )).promise().done( function() {
            do_process_cart( this_id, '', this_amount, task, '', '', '', used_unit_id, is_configurable, configurable_selection, configurable_pos_id);
            reset_val(event, src_input);
            if(!body_class( 'is_cart' )){
                new_stock = this_stock - Number(this_amount);
                if(!has_unit_id){
                    src_input.attr( 'data-stock', new_stock);
                }else{
                    update_units_stock_options(elem.closest( '.product_quantity' ).find( 'select option:selected' ), new_stock, elem.closest( '.product_quantity' ).find( 'select option'),this_amount);
                }
            }
        });
        // If the amount is greater than either stock or max order value
        // } else if ( this_amount > this_stock || this_amount > this_max && this_amount > 0 ) {
    } else if ( this_amount > this_stock && this_amount > 0 ) {
        // Has overbook means the product can be ordered outside of stock, but should be limited to the max order value
        if ( overbook && overbook > 0 ) {
            // Adjust the amount if max order value has been reached
            // if ( this_stock > this_max ) {
            //     this_amount = this_max;
            //     new_title = 'The current amount (' + amount_init + ') is exceeding the order limit (' + this_max + ').';
            // } else if ( this_stock <= this_max ) {
            //     this_amount = this_stock;
            //     new_title = 'The current amount (' + amount_init + ') is exceeding the stock limit (' + this_stock + ').';
            // }

            // Correct amount to process, check for minus values
            if ( (CVS_PARTIAL_DELIVERY === 'false' && (this_amount > this_stock || this_stock <= 0 || (this_stock < this_min && task === 'update_product'))) || (this_stock <= 0 && CVS_PARTIAL_DELIVERY === 'true')) {
                if (CVS_DISPLAY_OVERBOOK_MODAL === 'false') {
                    process_overbook_popup_request(task, this_amount, this_min, this_prod_name, this_unit_entity, this_id, this_pos_id, used_unit_id, src_input, event, this_stock, has_unit_id, elem);
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: GLOB_ATTENTION,
                        html: CART_OVERBOOK_BACKORDER,
                        showDenyButton: true,
                        confirmButtonText: BTN_CONTINUE,
                        denyButtonText: BTN_CANCEL,
                        showCloseButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            process_overbook_popup_request(task, this_amount, this_min, this_prod_name, this_unit_entity, this_id, this_pos_id, used_unit_id, src_input, event, this_stock, has_unit_id, elem);
                        } else if (result.isDenied) {
                            do_process_cart();
                        } else if ( result.dismiss ) {
                            // Separate event handler for future purposes ...
                            do_process_cart();
                        }
                    })
                }
            } else if(CVS_PARTIAL_DELIVERY === 'true') {
                Swal.fire({
                    // USAGE: https://animate.style/#usage
                    // showClass: {
                    //     popup: 'animate__animated animate__slideInUp'
                    // },
                    // hideClass: {
                    //     popup: 'animate__animated animate__fadeOutUp'
                    // },
                    customClass: {
                        container: 'modal_options'
                    },
                    icon: 'warning',
                    title: GLOB_ATTENTION,
                    html: CART_STOCK_OVERBOOK_TRIGGER.replace('%s', src_input.attr( 'data-stock' )),
                    showDenyButton: true,
                    confirmButtonText: BTN_CONTINUE,
                    denyButtonText: BTN_CANCEL,
                    showCloseButton: true,
                    input: 'radio',
                    inputOptions: inputOptions,
                    inputValue: src_input.attr( 'data-delivery_status' ),
                    inputValidator: (value) => {
                        if (!value) {
                            return GLOB_CHOOSE_OPTION;
                        }
                        selected_option = value;
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        // if ( backorder_note === 'stock' ) {
                        //     new_content  = '<li><b>' + amount_init + ' ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> was added to your cart and placed as backorder.';
                        //     // arg           = '<b>' + backorder_note + '</b> was choosen.';
                        // } else if ( backorder_note === 'all' ) {
                        //     new_content  = '<li><b>' + amount_init + ' ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> was added to your cart and placed as backorder.';
                        //     // arg           = '<b>' + backorder_note + '</b> was choosen.';
                        // } else if ( backorder_note === 'split' ) {
                        //     new_content  = '<li><b>' + this_amount + ' ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> was added to your cart.<br /><li><b>' + backorder_amount + ' ' + this_unit_entity + '</b> will be placed as backorder.';
                        //     // arg           = '<b>' + backorder_note + '</b> was choosen.';
                        // }

                        if ( selected_option === 'stock' ) {
                            this_amount = this_stock;
                            overbook_option = 0;
                        } else if ( selected_option === 'all' ) {
                            this_amount = amount_init;
                            overbook_option = 1;
                        } else if ( selected_option === 'split' ) {
                            this_amount = amount_init;
                            overbook_option = 2;
                        }
                        if ( task === 'update_product' ) {
                            new_content   = '<li>' + CART_ARTICLE_UPDATED_AMOUNT + ' <b>' +  this_prod_name + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_TO + ' <b>' + this_amount + ' ' + this_unit_entity + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_CHANGED;
                        } else {
                            new_content   = '<li><b>' + this_amount + ' ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> ' + CART_ARTICLE_ADDED;
                        }

                        toast_title = GLOB_SUCCESS;
                        toast_content = new_content;
                        toast_icon = 'success';

                        jQuery(do_toast(toast_title, toast_content, toast_icon, 3000, arg)).promise().done(function () {
                            do_process_cart(this_id, '', this_amount, task, '', '', overbook_option, used_unit_id, is_configurable, configurable_selection,configurable_pos_id);
                            reset_val(event, src_input);
                        });

                        if ( ! body_class( 'is_cart' )) {
                            new_stock = this_stock - Number( this_amount );
                            if ( ! has_unit_id ) {
                                src_input.attr( 'data-stock', new_stock );
                            } else{
                                update_units_stock_options(elem.closest( '.product_quantity' ).find( 'select option:selected' ), new_stock, elem.closest( '.product_quantity' ).find( 'select option'),this_amount);
                            }
                        }
                    } else if ( result.isDenied ) {
                        do_process_cart();
                    } else if ( result.dismiss ) {
                        // Separate event handler for future purposes ...
                        do_process_cart();
                    }
                })
            }
            // NO overbook means the product can only be ordered within the range of stock or max value
        } else if ( ! overbook || overbook === 0 ) {
            // If there is stock
            if ( this_stock && this_stock > 0 ) {
                // Adjust the amount value if needed, either based on stock or based on max value
                // if ( this_amount > this_stock && this_amount <= this_max ) {
                if ( this_amount > this_stock ) {
                    this_amount = this_stock;
                }
                /* else if ( this_amount > this_stock && this_amount > this_max ) {
                    if ( this_stock > this_max ) {
                        this_amount = this_max;
                        // new_title = 'The current amount (' + amount_init + ') is exceeding the order limit (' + this_max + ').';
                    } else if ( this_stock <= this_max ) {
                        this_amount = this_stock;
                        // new_title = 'The current amount (' + amount_init + ') is exceeding the stock limit (' + this_stock + ').';
                    }
                } else if ( this_amount <= this_stock && this_amount > this_max ) {
                    this_amount = this_max;
                    // new_title = 'The current amount (' + amount_init + ') is exceeding the order limit (' + this_max + ').';
                } */

                Swal.fire({
                    icon: 'warning',
                    title: GLOB_ATTENTION,
                    html: CART_ORDER_CORRECTION,
                    showDenyButton: true,
                    confirmButtonText: BTN_CONTINUE,
                    denyButtonText: BTN_CANCEL,
                    showCloseButton: true
                }).then((result) => {
                    if ( result.isConfirmed ) {
                        // Show add to cart toast
                        toast_title     = GLOB_SUCCESS;
                        if ( task === 'update_product' ) {
                            toast_content   = '<li>' + CART_ARTICLE_UPDATED_AMOUNT + ' <b>' +  this_prod_name + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_TO + ' <b>' + this_amount + ' ' + this_unit_entity + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_CHANGED;
                        } else {
                            toast_content   = '<li><b>' + this_amount + ' ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> ' + CART_ARTICLE_ADDED;
                        }
                        toast_icon = 'success';
                        jQuery( do_toast( toast_title, toast_content, toast_icon, 3000, arg )).promise().done( function() {
                            do_process_cart( this_id, '', this_amount, task, '', '', '', used_unit_id, is_configurable, configurable_selection, configurable_pos_id);
                            reset_val( event, src_input );
                        });

                        if ( ! body_class( 'is_cart' )) {
                            new_stock = this_stock - Number( this_amount );
                            if ( ! has_unit_id ) {
                                src_input.attr( 'data-stock', new_stock );
                            } else {
                                update_units_stock_options(elem.closest( '.product_quantity' ).find( 'select option:selected' ), new_stock, elem.closest( '.product_quantity' ).find( 'select option'),this_amount);
                            }
                        }
                    } else if ( result.isDenied ) {
                        do_process_cart();
                    } else if ( result.dismiss ) {
                        // Separate event handler for future purposes ...
                        do_process_cart();
                    }
                })
                // Lastly, there is no stock, and there is no overbook. The product can't be bought.
            } else if ( ! this_stock || this_stock === 0 ) {
                // Show unavailable toast
                toast_title     = GLOB_ATTENTION;
                toast_content   = CART_ARTICLE_UNAVAILABLE;
                toast_icon      = 'warning';

                jQuery( do_toast( toast_title, toast_content, toast_icon, 3000, arg )).promise().done( function() {
                    reset_val( event, src_input );
                });
            }
        }
    }
}

function process_overbook_popup_request(task, this_amount, this_min, this_prod_name, this_unit_entity, this_id, this_pos_id, used_unit_id, src_input, event, this_stock, has_unit_id, elem){
    let toast_title         = GLOB_SUCCESS;
    let toast_content       = '';
    let toast_icon          = 'success';
    let arg                 = '';
    let new_stock           = 0;

    if (task === 'update_product') {
        if (this_amount < this_min) {
            this_amount = this_min;
        }
        toast_content = '<li>' + CART_ARTICLE_UPDATED_AMOUNT + ' <b>' + this_prod_name + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_TO + ' <b>' + this_amount + ' ' + this_unit_entity + '</b> ' + CART_ARTICLE_UPDATED_AMOUNT_CHANGED;
    } else {
        toast_content = '<li><b>' + this_amount + ' ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> ' + CART_ARTICLE_ADDED;
    }

    jQuery(do_toast(toast_title, toast_content, toast_icon, 3000, arg)).promise().done(function () {
        do_process_cart(this_id, this_pos_id, this_amount, task, '', '', '1', used_unit_id);
        reset_val(event, src_input);
    });
    if (!body_class('is_cart')) {
        new_stock = this_stock - Number(this_amount);
        if (!has_unit_id) {
            src_input.attr('data-stock', new_stock);
        } else {
            update_units_stock_options(elem.closest('.product_quantity').find('select option:selected'), new_stock, elem.closest('.product_quantity').find('select option'), this_amount);
        }
    }
}

function update_units_stock_options(selected_option,new_stock,select_menu,this_amount ){
    jQuery(select_menu).each(function() {
        new_stock = Number(jQuery(this).attr( 'data-stock' ) - ((selected_option.attr( 'data-factor' )*this_amount)/jQuery(this).attr( 'data-factor' )));
        if(new_stock < 0 ){
            new_stock = 0;
        }
        jQuery(this).attr( 'data-stock', Math.floor(new_stock) );
    });
}

// Delete from cart
function delete_from_cart( event, elem, init ) {
    let src_input			= elem.closest( '.product_quantity' ).find( '.js_quantity_input' );
    let this_amount			= Number( src_input.val() );
    let this_min			= Number( src_input.data( 'min' ));
    let this_max			= Number( src_input.data( 'max' ));
    let this_id				= src_input.data( 'prod_id' );
    let this_pos_id			= src_input.data( 'pos_id' );
    let this_prod_name		= src_input.data( 'prod_name' );
    let this_stock			= Number( src_input.data( 'stock' ));
    let this_unit_entity	= src_input.data( 'unit_entity' );
    let this_unit_size		= Number( src_input.data( 'unit_size' )); // VPE?
    let overbook			= src_input.data( 'overbook' );

    let amount_init			= 0;

    if ( init ) {
        amount_init = init;
    } else {
        amount_init = this_amount;
    }

    // Toast
    let toast_title			= '';
    let new_title			= '';
    let toast_content		= '';
    let new_content			= '';
    let toast_icon			= '';
    let arg					= '';

    Swal.fire({
        icon: 'warning',
        title: GLOB_ATTENTION,
        html: CART_REMOVE_ARTICLE,
        showDenyButton: true,
        confirmButtonText: BTN_CONTINUE,
        denyButtonText: BTN_CANCEL,
        showCloseButton: true
    }).then((result) => {
        if ( result.isConfirmed ) {
            // Show remove from cart toast
            toast_title		= GLOB_SUCCESS;
            toast_content	= '<li><b>' + this_prod_name + '</b> ' + CART_ARTICLE_REMOVED;
            toast_icon		= 'success';

            jQuery( do_toast( toast_title, toast_content, toast_icon, 3000, arg )).promise().done( function() {
                do_process_cart( '', this_pos_id, '', 'delete_product' );
            });
        } else if ( result.isDenied || result.isDismissed ) {
            // For when triggered via focusout, set the old value
            if ( amount_init > 0 || amount_init !== 0 || amount_init !== 'undefined' ) {
                src_input.val( amount_init );
            } else {
                // console.log( 'broken stuff in delete_from_cart' );
            }

        }
    })
}

// Reset the input amount to init value
function reset_val( event, target ) {
    if(!body_class( 'is_cart' ) && !body_class( 'is_account_history_info' )) {
        let unit_size = Number(target.data('unit_size'));
        let this_min = Number(target.data('min'));
        // When the no_check class has been set it ignores the unit size in the amount calculation and will fall back to the min value
        let no_check = target.hasClass('no_check');
        let init_zero = target.hasClass('init_zero');

        if (no_check) {
            target.val(this_min);
        } else if (init_zero) {
            target.val(0);
        } else {
            target.val(unit_size);
        }
    }
}

// Check the quantity by click
function do_check_quantity( e, elem ) {
    let _this				= elem;
    let src_input			= _this.closest( '.product_quantity' ).find( '.js_quantity_input' );
    let this_amount			= Number( src_input.val() );
    let this_id				= src_input.data( 'prod_id' );
    let this_pos_id			= src_input.data( 'pos_id' );
    let used_unit_id		= src_input.data( 'used_unit_id' );
    let this_min			= src_input.data( 'min' );
    let overbook			= src_input.data( 'overbook' );
    let amount_init			= this_amount;
    let is_variant_list			= jQuery("#main_wrapper").find("#main_varianten_listing");

    // Promise to amount check first ...
    jQuery( do_check_amount( e, src_input ) ).promise().done( function() {
        let key		= Object.keys( this )[0];
        let value	= this[key];

        if ( value === true ) {
            jQuery( do_calc_amount( e, _this ) ).promise().done( function() {
                // Get the new calculated value
                let key		= Object.keys( this )[0];
                let value	= this[key];

                // If value is greater than 0 and not undefined
                if ( value > 0 && value !== 'undefined' ) {
                    // In cart trigger AJAX call to update amount
                    if ( body_class( 'is_cart' ) ) {
                        // do_process_cart( this_id, this_pos_id, value, 'update_product', '', '', overbook, used_unit_id);
                        add_to_cart( e, elem, amount_init );
                    } else {
                        src_input.val( value );
                    }
                    // If remove is triggered
                } else {
                    // In cart trigger AJAX call to update amount
                    if ( body_class( 'is_cart' ) ) {
                        delete_from_cart( e, src_input, amount_init );
                    } else if ( !is_variant_list.length ) {
                        src_input.val( this_min );
                    }
                }
            });
        }
    });
}

// Add / subtract the amount value including unit amount values
function do_calc_amount( event, elem ) {
    let src_input			= elem.closest( '.product_quantity' ).find( '.js_quantity_input' );
    let this_trigger		= elem.data( 'trigger' );
    let this_amount			= Number( src_input.val() );
    let new_amount			= 0;
    let this_min			= Number( src_input.data( 'min' ));
    let this_max			= Number( src_input.data( 'max' ));
    let this_id				= src_input.data( 'prod_id' );
    let this_pos_id			= src_input.data( 'pos_id' );
    let this_prod_name		= src_input.data( 'prod_name' );
    let this_stock			= Number( src_input.data( 'stock' ));
    let this_unit_entity	= src_input.data( 'unit_entity' );
    let unit_size		    = Number( src_input.data( 'unit_size' )); // VPE?
    let overbook			= src_input.data( 'overbook' );
    let amount_init			= this_amount;
    let is_variant_list			= jQuery("#main_wrapper").find("#main_varianten_listing");

    if ( this_trigger === 'plus' ) {
        // For unit sizes
        if ( unit_size > 1 ) {
            new_amount = this_amount + unit_size;
            // Normal
        } else {
            new_amount = this_amount + 1;
        }
        if ( new_amount < this_min && is_variant_list.length) {
            new_amount = this_min;
        }
    } else if ( this_trigger === 'min' ) {
        // For unit sizes
        if ( this_amount > unit_size && unit_size > 1 ) {
            new_amount = this_amount - unit_size;
            // Normal
        } else if ( this_amount > unit_size && unit_size === 1 ) {
            new_amount = this_amount - 1;
            // Remove product OR reset to min amount
        } else if ( this_amount < unit_size || this_amount < 1 || this_amount === 0 ) {
            // TODO: Add remove from cart when amount is 0
            // TODO: Prevent value to be set as 0 outside cart
            if ( body_class( 'is_cart' ) ) {
                // console.log( 'remove from cart 0 amount' );
                new_amount = 0;
            } else {
                // console.log( 'reset to min amount' );
                if(!(is_variant_list.length && new_amount < this_min)) {
                    new_amount = this_min;
                }
            }
        }
        // Check with min amount fallback
        if ( new_amount < this_min && ! body_class( 'is_cart' )  && !is_variant_list.length) {
            new_amount = this_min;
        }else if(is_variant_list.length && new_amount < this_min) {
            new_amount = 0;
        }

    }
    // Set new input value
    src_input.val( new_amount );
    // Needed for plus / minus buttons
    return new_amount;
}

// Check the amount value for legitimacy
function do_check_amount( event, elem, src ) {
    // First grab the event type that was triggered
    let event_type			= event.type;
    // Moving on ...
    let src_input			= elem;
    let this_amount			= Number( src_input.val() );
    let new_amount			= 0;
    let this_min			= Number( src_input.data( 'min' ));
    let this_max			= Number( src_input.data( 'max' ));
    let this_id				= src_input.data( 'prod_id' );
    let this_pos_id			= src_input.data( 'pos_id' );
    let this_prod_name		= src_input.data( 'prod_name' );
    let this_stock			= Number( src_input.data( 'stock' ));
    let this_unit_entity	= src_input.data( 'unit_entity' );
    let unit_size		    = Number( src_input.data( 'unit_size' )); // VPE?
    let overbook			= src_input.data( 'overbook' );
    let used_unit_id		= src_input.data( 'used_unit_id' );
    let amount_init			= this_amount;

    // When the no_check class has been set it ignores the unit size in the amount calculation and will fall back to the min value
    let no_check			= src_input.hasClass( 'no_check' );

    // Debug ...
    //console.log( 'Event type: ' + event_type );

    if ( event_type === 'keyup' ) {
        let key = 'which' in event ? event.which : event.keyCode;

        // When ENTER key is pressed
        if ( key === 13 ) {
            src_input.blur();
            // When ESC key is pressed
        } else if ( key === 27 ) {
            if ( this_amount > 0 && no_check ) {
                src_input.val( this_min );
            } else {
                src_input.val( unit_size );
            }
            // Point of no return ...
        } else {
            return false;
        }
    } else if ( event_type === 'focusout' ) {
        // Algorithm - Getting the division ratio value
        let times_value		= Math.abs(this_amount / unit_size ).toFixed(1 );
        let division_ratio	= Math.abs( times_value );
        division_ratio		= division_ratio - Math.floor( division_ratio );
        division_ratio		= division_ratio.toFixed(1 ).split('.' )[1];

        if ( this_amount !== 0 || this_amount > 0 ) {
            // Round the new amount value based on division ratio with balanced threshold
            // Rounding up
            if ( division_ratio >= 5 && this_amount > unit_size ) {
                new_amount = parseInt(Math.ceil(this_amount / unit_size ) * unit_size );
                // Rounding down
            } else if ( division_ratio < 5 && this_amount > unit_size ) {
                new_amount = parseInt(Math.floor(this_amount / unit_size ) * unit_size );
                // Fall back to default
            } else {
                if ( no_check ) {
                    new_amount = this_min;
                } else {
                    new_amount = unit_size;
                }
            }
        }

        if(new_amount < this_min){
            new_amount = this_min;
        }
        // In cart
        if ( body_class( 'is_cart' ) ) {
            if ( this_amount !== 0 && this_amount > 0 ) {
                // console.log( 'AJAX - UPDATE CART' );
                // do_process_cart( this_id, this_pos_id, new_amount, 'update_product', '', '', overbook, used_unit_id );
                add_to_cart( event, elem );
            } else if ( this_amount < 1 || this_amount === 0 ) {
                // console.log( 'AJAX - DELETE PRODUCT FROM CART' );
                delete_from_cart( event, elem, amount_init );
            }
            // Everywhere else
        } else {
            src_input.val( new_amount );
        }
    }

    // Return needed as conditional value in order to proceed in promise()
    return true;
}

// inputOptions can be an object or Promise ...
let inputOptions;

if ( CVS_OVERRIDE_STOCK === 'true' && CVS_PARTIAL_DELIVERY === 'true' ) {
    inputOptions = new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                'stock' : MODAL_ARTICLE_OPTION_STOCK,
                'all'	: MODAL_ARTICLE_OPTION_ALL,
                'split'	: MODAL_ARTICLE_OPTION_SPLIT,
            })
        }, 250 );
    });
} else {
    inputOptions = new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                'stock' : MODAL_ARTICLE_OPTION_STOCK,
                'all'	: MODAL_ARTICLE_OPTION_ALL,
            })
        }, 250 );
    });
}

// Toast notification
function do_toast( title, content, icon, new_timer, note, center, custom_class, btn_confirm, btn_confirm_txt ) {

    // Remove any previous toast(s)
    jQuery( '.toast-item-wrapper' ).remove();

    let set_time	= 0;
    let set_content	= '';
    let position	= '';

    if ( new_timer ) {
        set_time = new_timer;
    } else {
        set_time = 2500;
    }

    if ( note ) {
        set_content = content + '<br /><br />' + note;
    } else {
        set_content = content;
    }

    if ( center ) {
        position = 'toast-center-center';
    } else {
        position = 'toast-top-right';
    }

    jQuery.Toast(
        title,
        set_content,
        icon, {
            appendTo: 'body', // append to body
            stack: false, // is stackable?
            // 'toast-top-left'
            // 'toast-top-right'
            // 'toast-top-center'
            // 'toast-bottom-left'
            // 'toast-bottom-right'
            // 'toast-bottom-center'
            custom_class: custom_class, // CVS custom
            position_class: position,
            fullscreen: false, // fullscreen
            width: 450, // width
            spacing: 10, // vertical spacing between toasts
            timeout: set_time, // in milliseconds
            has_close_btn: true,
            has_confirm_btn: btn_confirm, // CVS custom
            confirm_btn_text: btn_confirm_txt, // CVS custom
            has_icon: true, // has icon
            sticky: false, // is sticky
            border_radius: 0, // border radius in pixels
            has_progress: true, // has progress bar
            rtl: false // RTL support
        });
}

// ----------------------------

// Alternative HTML based messaging instead of using the native alert function
// TODO: Migrate to modal or toast!
function message( type, title, mssg, action_ok, action_cancel, single, txt1, txt2 ) {
    if ( single == true ) {
        jQuery( '.bt_cancel' ).hide();
    } else {
        jQuery( '.bt_cancel' ).show();
    }

    if ( ! action_ok || action_ok === '' || action_ok === 'undefined' ) {
        action_ok = '';
    } else {
        action_ok = action_ok + ';';
    }

    if ( ! action_cancel || action_cancel === '' || action_cancel === 'undefined' ) {
        action_cancel = 'close_message(); mask_layer( false );';
    } else {
        action_cancel = action_cancel + ';';
    }

    switch ( type ) {
        case 'success':
            jQuery( '#message' ).addClass( 'message_success' );
            break;

        case 'alert':
            jQuery( '#message' ).addClass( 'message_alert' );
            break;

        case 'warning':
            jQuery( '#message' ).addClass( 'message_warning' );
            break;
    }

    mask_layer( true );

    jQuery( '.message_title_content' ).html( title );
    jQuery( '.message_content_txt' ).html( mssg );
    jQuery( '.bt_confirm' ).attr( 'onclick', action_ok );
    jQuery( '.bt_cancel' ).attr( 'onclick', action_cancel );
    jQuery( '#message' ).show();
}

// Closing message notification
function close_message() {
    jQuery( '.message_title_content' ).html( '' );
    jQuery( '.message_content_txt' ).html( '' );
    jQuery( '#message' ).hide();
    jQuery( '#message' ).removeClass( 'message_success message_alert message_warning' );
}

// ----------------------------

// Legacy toast function
// TODO: Migrate to new toast function - search for legacy usage!
// TODO: Migrate to CSS animations?
function notify( mssg ) {
    let inline_mssg = jQuery( '.ajax_notification_wrapper' );

    setTimeout( function() {
        mask_layer( true );
        inline_mssg.html( mssg ).addClass( 'mssg succes_msg' ).fadeIn( 250 );

        setTimeout( function() {
            inline_mssg.fadeOut( 750 );

            if ( has_overlay ) {
                mask_layer( true );
            } else {
                mask_layer( false );
            }
        }, 3000 );
    }, 100 );
}

// ----------------------------

// Datepicker init
function set_datepicker() {
    let has_datepicker = jQuery( '.js_datepicker' ).length;

    if ( has_datepicker && typeof has_datepicker !== 'undefined' ) {
        // Set local language set to all datepickers
        jQuery.datepicker.setDefaults( jQuery.datepicker.regional[ languages_code ] );

        // Set correct min_date OR max_date - prevent date selection
        let min_date = '';
        let max_date = '';
        if ( body_class( 'is_belege' )) {
            min_date = belege_oldest_date;
            max_date = belege_last_date;
        }


        // Initialize datepicker used by receipts overview
        jQuery( '.js_datepicker' ).datepicker({
            minDate: min_date,
            maxDate: max_date,
            beforeShow: function( input, inst ) {
                let _this           = jQuery( this );
                let target_wrapper  = _this.closest( '.calendar_icon' );
                let target_margin   = target_wrapper.height();

                setTimeout( function() {
                    jQuery( '.ui-datepicker' ).css( 'z-index', 10 ).css( 'top', target_margin ).css( 'left', '0' );
                    target_wrapper.append( jQuery( '#ui-datepicker-div' ));
                }, 10 );
            },
            onSelect: function( selectedDate ) {
                if ( body_class( 'is_belege' )) {
                   filter_belege_list();
                }
            }
        })
    }
}

// ----------------------------
function filter_belege_list(){
    let start_date = jQuery( '#start_date' ).val();
    let end_date = jQuery( '#end_date' ).val();
    let selected_types	= [];
    jQuery( '.js_belege_selected_types' ).each( function( index ) {
        if(jQuery( this ).prop( 'checked' )){
            selected_types.push({
                'type': jQuery( this ).val()
            });
        }
    });
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            start_date: start_date,
            end_date: end_date,
            ajax_selected_types: JSON.stringify( selected_types ),
            ajax_action: 'product_listing',
            function: 'filter_belege'
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            populate_product_list_content( data.list );
            loading( false );
        },
        complete: function( data ) {
        },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}
// ----------------------------

// Global autocomplete
// TODO: Use active class!
function do_autocomplete( event, state, elem ) {
    let this_container	= elem.closest( '.autocomplete_container ' );
    let this_parent		= elem.closest( '.autocomplete' );
    let this_input		= this_parent.find( '.js_autocomplete' );
    let this_ref		= this_parent.attr( 'data-ref' );
    let this_val		= jQuery.trim( elem.val() );
    let results_box		= this_parent.find( '.autocomplete_results_box' );
    let results		    = results_box.find( '.autocomplete_results' );
    let results_footer	= results_box.find( '.autocomplete_footer' );
    let result			= results.find( '.autocomplete_result' );
    let result_active	= results.find( '.autocomplete_result.active' );
    let has_active	    = results.find( '.autocomplete_result' ).hasClass( 'active' );
    let category_id     = this_input.attr('data-selected_category_id');

    let result_active_url		= result_active.attr( 'data-url' );
    let result_active_id		= result_active.attr( 'data-prod_id' );
    let result_active_overbook	= result_active.attr( 'data-overbook' );

    let currentRequest	= null;

    let securityTokenSearch = this_parent.find('[name="securityTokenSearch"]').val();

    if ( state === 'open' ) {
        let key = 'which' in event ? event.which : event.keyCode;

        if ( key !== 38 && key !== 40 && key !== 27 && key !== 37 && key !== 39 ) {
            if ( this_val.length >= 3 || (this_val.length === 0 && this_ref === 'main' && CVS_SHOW_MOST_SEARCHED_ITEMS ==='true')) {
                currentRequest = jQuery.ajax({
                    type: 'post',
                    url: ajax_url_global + Math.random(),
                    data: {
                        max_rows: 99,
                        user_input: this_val,
                        search_method: 'contain',
                        ajax_action: 'auto_complete_search',
                        function: 'get_products',
                        param: this_ref,
                        cat_id : category_id,
                        securityToken: securityTokenSearch,
                    },
                    async: true,
                    dataType: 'json',
                    beforeSend: function () {
                        if (currentRequest != null) {
                            results.html('<div class="autocomplete_result">' + search_in_progress + '</div>');
                            currentRequest.abort();
                        }
                    },
                    success: function (data) {
                        // Set output variables
                        let results_content         = '';
                        let results_footer_content  = '';
                        let results_count           = data.totalResultsCount;

                        if ( results_count > 0 || (this_val.length === 0 && this_ref === 'main')) {
                            results_content += data.autocomplete_result;
                            results_footer_content += data.autocomplete_footer;
                            if(this_val.length === 0 && this_ref === 'main'){
                                results_footer.html( '' ).hide();
                            }
                        } else {
                            results_content += data.autocomplete_no_result;
                            results_footer.html( '' ).hide();
                        }

                        // Populate results box / results footer
                        results.html( results_content );
                        if ( this_ref === 'main' && results_count > 0 ) {
                            results_footer.html( results_footer_content ).show();
                        }
                    },
                    complete: function () {
                        // Show results box
                        results_box.removeClass( 'hide_it' ).addClass( 'show_it' );
                    },
                    error: function () {
                        console.log( 'Something went wong... hai!' );
                    }
                });
            } else {
                // Hide / empty results box
                results_box.removeClass( 'show_it' ).addClass( 'hide_it' );
                results.html( '' );
            }
        } else if ( key === 38 || key === 40 ) {
            let strLength;
            let proceed = false;

            // Up key
            if ( key === 38 ) {
                proceed = false;

                if ( has_active ) {
                    result_active.removeClass( 'active' ).prev().addClass( 'active' );
                    // Now that we have an active class set we may proceed checking the scrolling
                    proceed = true;
                }
            }

            // Down key
            if ( key === 40 ) {
                proceed = false;

                if ( has_active ) {
                    if ( result_active.is( ':last-child' ) ) {
                        result_active.removeClass( 'active' );
                        results.scrollTop( 0 );
                        this_input.focus();
                        return false;
                    } else {
                        result_active.removeClass( 'active' ).next().addClass( 'active' );
                        proceed = true;
                    }
                } else if ( this_input.is( ':focus' ) ) {
                    results.children( '.autocomplete_result:first' ).addClass( 'active' );
                }
            }

            strLength = this_val.length * 2;
            this_input.focus();
            elem[0].setSelectionRange( strLength, strLength );

            // Correct scroll
            if ( proceed === true ) {
                do_autocomplete_scroll( key, results, result_active );
            }
        } else if ( key === 27 ) {
            if ( this_input.is( ':focus' ) ) {
                this_input.blur().val( '' );
                results_box.removeClass( 'show_it' ).addClass( 'hide_it' );
            }

            // do_autocomplete_reset( event, this_input );
        } else if ( key === 10 || key === 13 ) {
            event.preventDefault();
            return false;
        }
    }

    if ( state === 'close' && this_val.length >= 3 ) {
        // results_box.removeClass( 'show_it' ).addClass( 'hide_it' );
    }
}

// Trigger clicked search result
function do_autocomplete_result( event, elem , arg ) {
    let this_parent	        = elem.closest( '.autocomplete' );
    let this_grand_parent	= this_parent.closest( '.autocomplete_cat' );
    let search_category	= '';
    if ( this_grand_parent.length && typeof this_grand_parent.length !== 'undefined' ) {
        let search_category_menu        = this_grand_parent.find( '.js_search_categories_dropdown' );
        search_category	= '&search_category=' + search_category_menu.find(":selected").val();
    }
    let parent_ref	        = this_parent.attr( 'data-ref' );
    let search_input        = this_parent.find( '.js_autocomplete' );
    let search_val	        = search_input.val();
    let results_box		    = this_parent.find( '.autocomplete_results_box' );
    let this_url		    = elem.data( 'url' );
    let this_id		        = elem.data( 'prod_id' );
    let this_stock	        = elem.data( 'stock' );
    let this_unit_entity	= elem.data( 'unit_entity' );
    let this_prod_name		= elem.data( 'prod_name' );
    // Active line
    let has_active	        = this_parent.find( '.autocomplete_result' ).hasClass( 'active' );
    let result_active	    = this_parent.find( '.autocomplete_result.active' );
    let result_active_url	= result_active.attr( 'data-url' );
    let result_id           = result_active.attr( 'data-prod_id' );
    let result_overbook = 0;
    if ( parent_ref === 'cart' ) {
        result_overbook = elem.data('overbook');
    }

    // Triggered from ENTER key
    if ( search_val.length >= 3 ) {
        if ( arg ) {
            if ( parent_ref === 'main' ) {
                if ( has_active ) {
                    go_navigate( '', result_active_url );
                } else {
                    go_navigate( '',adv_search_url + search_val + search_category );
                }
            }

            if ( parent_ref === 'cart' ) {
                if ( has_active ) {
                    do_process_cart(result_id, '', '1', 'add_product', '', '', result_overbook);
                } else {
                    return false;
                }
            }
        } else {
            if ( parent_ref === 'main' ) {
                if ( elem.is( '.autocomplete_result' ) ) {
                    go_navigate( '', this_url );
                } else {
                    go_navigate( '', adv_search_url + search_val + search_category );
                }
            }

            if ( parent_ref === 'cart' ) {
                if ( this_stock <= 0 && CVS_DISPLAY_OVERBOOK_MODAL === 'true') {
                    Swal.fire({
                        icon: 'warning',
                        title: GLOB_ATTENTION,
                        html: CART_OVERBOOK_BACKORDER,
                        showDenyButton: true,
                        confirmButtonText: BTN_CONTINUE,
                        denyButtonText: BTN_CANCEL,
                        showCloseButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            new_content = '<li><b>1 ' + this_unit_entity + '</b> <b>' + this_prod_name + '</b> ' + CART_ARTICLE_ADDED;

                            toast_title = GLOB_SUCCESS;
                            toast_content = new_content;
                            toast_icon = 'success';

                            jQuery( do_toast( toast_title, toast_content, toast_icon, 3000, arg ) ).promise().done(function () {
                                do_process_cart(this_id, '', '1', 'add_product', '', '', '1');
                            });
                        }
                    })
                } else {
                    do_process_cart(this_id, '', '1', 'add_product', '', '', result_overbook);
                }
            }
        }
    } else {
        return false;
    }
}

// Reset search
// TODO: Use active class!
function do_autocomplete_reset( event, elem ) {
    let this_parent 	= elem.closest( '.autocomplete' );
    let target_input	= this_parent.find( '.js_autocomplete' );
    let results_box		= this_parent.find( '.autocomplete_results_box' );
    let results		    = this_parent.find( '.autocomplete_results' );

    target_input.val( '' );
    results_box.removeClass( 'show_it' ).addClass( 'hide_it' );
    results.html( '' );
}

// Trigger search results scroll
function do_autocomplete_scroll( keyval, obj_autocomplete_results, obj_active_result ) {
    let key = keyval;

    let scroll_pos			= parseInt( Math.abs( obj_autocomplete_results.scrollTop() ));
    let results_height		= parseInt( Math.abs( obj_autocomplete_results.height() ));
    let result_pos			= parseInt( Math.abs( obj_active_result.position().top ));
    let result_height		= parseInt( Math.abs( obj_active_result.height() ));
    let result_pos_bottom	= result_pos + result_height;
    let new_scroll_pos		= scroll_pos + ( result_pos - 30 );

    // console.log(	'scroll_pos: ' + scroll_pos +
    // 				' | results_height: ' + results_height +
    // 				' | result_pos: ' + result_pos +
    // 				' | result_height: ' + result_height +
    // 				' | result_pos_bottom: ' + result_pos_bottom +
    // 				' | new_scroll_pos: ' + new_scroll_pos );

    // Scrolling up
    if ( key === 38 ) {
        if ( result_pos > 0 && result_pos <= result_height ) {
            obj_autocomplete_results.scrollTop( scroll_pos - ( results_height - result_pos_bottom ) );
        }
    }

    // Scrolling down
    if ( key === 40 ) {
        if ( result_pos > 0 && ( result_pos + result_height ) >= results_height ) {
            obj_autocomplete_results.scrollTop( new_scroll_pos - result_height );
        }
    }
}

// ----------------------------

// Get articles from modal and add to cart
function get_modal_articles( file ) {
    let target_container    = jQuery( '[class*="js_upload_container"]' );
    let target_input_txt    = jQuery( '[class*="js_upload_text"]' );

    let message			= '';
    let toast_title		= '';
    let toast_content	= '';

    jQuery.ajax({
        url: ajax_upload_csv_url_global + Math.random(),
        dataType: 'text',  // <-- what to expect back from the PHP script, if anything
        cache: false,
        contentType: false,
        processData: false,
        data: file,
        type: 'post',
        success: function( response ) {
            // Do cart init
            do_process_cart();

            let ajax_response = JSON.parse( response );
            let added_to_cart_flag =  ajax_response.response_added_to_cart_flag;
            // Success
            if ( ajax_response.response_code === 100 ) {
                // Show add to cart success toast
                toast_title     = GLOB_SUCCESS;
                toast_content   = CART_ADDED_SUCCESS;
                toast_icon      = 'success';

                do_toast( toast_title, toast_content, toast_icon, 3000, '', true );
            }

            // Warning: overbook products + invalid products + not for sale products
            if ( ajax_response.response_code === 150 ) {
                // Set HTML content
                message += ajax_response.response_content;

                if ( parseInt( ajax_response.response_overbook_products_count ) > 0 ) {
                    // Get HTML form and set content
                    message += ajax_response.response_overbook_products_form;
                    let showCancelButton = false;
                    if(parseInt( ajax_response.response_overbook_check_products_count ) > 0){
                        showCancelButton = true;
                    }
                    Swal.fire({
                        customClass: {
                            container: 'modal_large'
                        },
                        icon: 'warning',
                        title: GLOB_ATTENTION,
                        html: message,
                        width: '80vw',
                        focusConfirm: false,
                        showDenyButton: showCancelButton,
                        confirmButtonText: BTN_CONTINUE,
                        denyButtonText: BTN_CANCEL,
                        showCloseButton: true,
                        preConfirm: () => {
                            // Nested function to keep focus
                            function do_grab_overbook_values() {
                                // Checked radio
                                let radio = jQuery( '.swal2-popup' ).find( 'input:checked' );
                                // Grab all selected radio values
                                radio.each( function( index, elem ) {
                                    let _this			= jQuery( this );
                                    let this_id			= _this.data( 'id' );
                                    let this_quantity	= _this.data( 'quantity' );
                                    let this_stock		= _this.data( 'stock' );
                                    let this_val		= _this.val();
                                    let this_amount		= '';

                                    if ( this_val === '1' ||  this_val === '2' ) {
                                        this_amount = this_quantity;
                                    } else {
                                        this_amount = this_stock;
                                    }

                                    modal_articles.push({
                                        product_id	: this_id,
                                        quantity	: this_amount,
                                        overbook	: this_val,
                                    });
                                });
                            }

                            jQuery( do_grab_overbook_values() ).promise().done( function() {
                                do_process_overbook_list();
                                // Empty array
                                modal_articles = [];
                            });
                        }
                    }).then(( result ) => {
                        // Confirm
                        if ( result.isConfirmed && added_to_cart_flag == '1') {
                            // Show add to cart success toast
                            toast_title     = GLOB_SUCCESS;
                            toast_content   = CART_ADDED_SUCCESS;
                            toast_icon      = 'success';

                            do_toast( toast_title, toast_content, toast_icon, 3000, '', true );
                            // Empty array
                            modal_articles = [];
                        }
                    })
                } else {
                    // Warning
                    toast_title     = GLOB_ATTENTION;
                    toast_content   = CART_ARTICLES_UNAVAILABLE;
                    toast_icon      = 'warning';

                    do_toast( toast_title, toast_content, toast_icon, 5000, '', true );
                }
            }

            // Error
            if ( ajax_response.response_code === 200 ) {
                // Show error toast
                toast_title     = GLOB_ERROR;
                toast_content   = FILE_UPLOAD_CORRUPT;
                toast_icon      = 'error';

                do_toast( toast_title, toast_content, toast_icon, 5000, '', true );
            }
            // Set filename in input
            target_input_txt.html( ajax_response.file_name );
        }
    });
}

// Toggle container(s) in modal
function do_toggle_modal_container( event, elem ) {
    let _this       = jQuery( elem );
    let this_parent = _this.closest( '.container_wrapper' );
    let this_target = this_parent.find( '.ignored' );

    _this.toggleClass( 'active' );
    this_target.toggle();
}

// Process the overbook list
function do_process_overbook_list(update_stock_only) {
    if ( ! update_stock_only ) {
        update_stock_only = 0;
    }
    let ajax_function = 'update_product_stock_list';
    if(update_stock_only){
        ajax_function = 'update_product_stock_status';
    }
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            arr: JSON.stringify( modal_articles ),
            ajax_action: 'shopping_cart',
            function: ajax_function
        },
        async: true,
        dataType: 'json',
        success: function(data) {
            // Do cart init
            do_process_cart();
            if(update_stock_only){
                go_navigate('', 'index.php?main_page=checkout_shipping');
            }
        },
        complete: function() { },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

// ----------------------------

// WATCH LIST

// Process stored list name change
function new_list_name( id, value ) {
    jQuery.ajax({
        // cache: false,
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            listID: id,
            name: value,
            ajax_action: 'shopping_list',
            function: 'save_list_name'
        },
        async: false,
        dataType: 'json',
        success: function( data ) {
            jQuery( '.js_edit_container' ).hide();
            jQuery( '.watch_list_name_heading' ).html( value );
        },
        complete: function() { },
        error: function() {
            console.log( 'Something went wong... hai!' );
        }
    });
}

// Watchlist counter stuff
function do_watchlist() {
    let watchlist_counter = jQuery( '.pagehead_container' ).find( '.watchlist_count' );
    // Some AJAX'ing
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_action: 'shopping_list',
            function: 'count_watch_lists'
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            // Update watchlist balloon counter ...
            if ( ! data.watchlist_count || data.watchlist_count === '' ) {
                watchlist_counter.html( 0 );
            } else {
                watchlist_counter.html( data.watchlist_count );
            }
        },
        complete: function( data ) {},
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

// ----------------------------

function check_360_slider() {
    let container_360           = jQuery( '#threesixty_slider_container' );
    // let container_360_sub       = jQuery('#threesixty_slider_subcontainer');
    let has_container_360       = container_360.length;

    if ( has_container_360 && typeof has_container_360 !== 'undefined' ) {
        let product_id          = container_360.data( 'id' );
        let img_container_w     = jQuery( '.article_image_container' ).width();
        let thumb_slider_w      = jQuery( '.product_thumb_slider' ).width();
        let product_slider_w    = jQuery( '.product_slider' ).width();
        let available_width     = Math.round( img_container_w - thumb_slider_w - 30 );
        let max_size            = jQuery( '.article_cell_detail  .article_image_container picture img' ).css( 'max-height' ).replace( 'px', '' );

        // Set limit
        if ( available_width > max_size ) {
            available_width = max_size;
        }

        // console.log( available_width );
        // console.log( max_size );

        jQuery.ajax({
            type: 'POST',
            url: ajax_url_global + Math.random(),
            data: {
                ajax_action: 'general_settings',
                function: 'get_360grad_images',
                product_id: product_id
            },
            success: function( data ) {
                // let image_width	= parseFloat( data.imageWidth );
                // let image_height	= parseFloat( data.imageHeight );
                // Use init sizes for rendering
                let image_width		= parseFloat( available_width );
                let image_height	= parseFloat( available_width );

                // You can find all the info about the ThreeSixty Class in github:
                // https://github.com/mladenilic/threesixty.js
                let threesixty = new ThreeSixty( document.getElementById('threesixty_slider_subcontainer' ), {
                    // Image source
                    image: data.image,
                    // Sprite options (If array of images are provided, these options are ignored)
                    count: parseFloat( data.imageCount ), // Total number of images. Default: 0
                    perRow: parseFloat( data.imagePerRow ),
                    // Width & Height
                    width: image_width, // Image width. Default 300
                    height: image_height, // Image height. Default 300
                    // Navigation
                    // prev: document.getElementById('prev'), // Previous button element. Default: null
                    // next: document.getElementById('next'), // Next button element. Default: null
                    keys: true, // Rotate image on arrow keys. Default: true
                    draggable: true, // Rotate image by dragging. Default: true
                    swipeable: true, // Rotate image by swiping on mobile screens. Default: true
                    dragTolerance: 10, // Rotation speed when dragging. Default: 10
                    swipeTolerance: 10, // Rotation speed when swiping. Default: 10
                    swipeTarget: document.getElementById('threesixty_slider_container' ), // Element which will listen for drag/swipe events. Default: Image container
                    // Rotation settings
                    speed: 100, // Rotation speed during 'play' mode. Default: 10
                    inverted: false // Inverts rotation direction
                });
                // Start rotation
                threesixty.play();
            },
            complete: function() { }
        });
    }
}

// ----------------------------

// Sort ordered items
function order_sort_items( index ) {
    if ( index == 0 ) {
        return false;
    } else {
        switch( index ) {

            case '1':
                jQuery( '.ajax_product_listing div.account_order_container' ).sort( function( a, b ) {
                    return parseInt( jQuery( b ).attr( 'data-sort-date' ) ) > parseInt( jQuery( a ).attr( 'data-sort-date' ) );
                }).appendTo( '.ajax_product_listing' );
                break;

            case '2':
                jQuery( '.ajax_product_listing div.account_order_container' ).sort( function( a, b ) {
                    return parseInt( jQuery( b ).attr( 'data-sort-date' ) ) < parseInt( jQuery( a ).attr( 'data-sort-date' ) );
                }).appendTo( '.ajax_product_listing' );
                break;

            case '3':
                jQuery( '.ajax_product_listing div.account_order_container' ).sort( function( a, b ) {
                    return parseInt( jQuery( b ).attr( 'data-sort-price' ) ) > parseInt( jQuery( a ).attr( 'data-sort-price' ) );
                }).appendTo( '.ajax_product_listing' );
                break;

            case '4':
                jQuery( '.ajax_product_listing div.account_order_container' ).sort( function( a, b ) {
                    return parseInt( jQuery( b ).attr( 'data-sort-price' ) ) < parseInt( jQuery( a ).attr( 'data-sort-price' ) );
                }).appendTo( '.ajax_product_listing' );
                break;

            case '5':
                jQuery( '.ajax_product_listing div.account_order_container' ).sort( function( a, b ) {
                    return parseInt( jQuery( b ).attr( 'data-sort-amount' ) ) > parseInt( jQuery( a ).attr( 'data-sort-amount' ) );
                }).appendTo( '.ajax_product_listing' );
                break;

            case '6':
                jQuery( '.ajax_product_listing div.account_order_container' ).sort( function( a, b ) {
                    return parseInt( jQuery( b ).attr( 'data-sort-amount' ) ) < parseInt( jQuery( a ).attr( 'data-sort-amount' ) );
                }).appendTo( '.ajax_product_listing' );
                break;
        }
    }
}

// Reset orders filter
function reset_orders_filter() {
    jQuery( 'input[name="js_filter_orders"]' ).val( '' ).blur();
    jQuery( '.account_order_container' ).show();
    jQuery( '.js_order_grouping' ).show();
    jQuery( '.js_no_filtered_orders_found' ).hide();
}

// ----------------------------
// Checkout express trigger
function trigger_shipping_change(){
    jQuery( 'input[name="shipping"]' ).each( function( index, value ) {
        if ( jQuery( this ).prop( 'checked' ) ) {
            jQuery( this ).trigger( 'click' );
        }
    });
}
// ----------------------------

function trigger_menu_hover_change(){
    let has_category_folder_menu = jQuery( 'li.js_adjust_menu_hover_class' );
    if( typeof has_category_folder_menu !== 'undefined' && has_category_folder_menu.length){
        jQuery( '.js_main_cat_menu' ).removeClass('active');
        jQuery( '.js_main_cat_menu' ).find('li.active').removeClass('active');
    }
}
// ----------------------------
// Contains word
function containsWord( haystack, needle ) {
    return ( ' ' + haystack + ' ' ).indexOf( '' + needle + '' ) != -1;
}

// ----------------------------
// adjust the url via javascript with push state method
function change_url_state( new_url){
    history.replaceState(null, '', new_url.replaceAll('&amp;', '&'));
}
// ----------------------------
// express coupon
function process_coupon_express_checkout(coupon_code, $action = 'add'){
    if(coupon_code !== ''){
        jQuery.ajax({
            type: 'post',
            url: ajax_url_global + Math.random(),
            data: {
                dc_redeem_code: coupon_code,
                ajax_action: 'express_checkout',
                function: 'process_coupon'
            },
            dataType: 'json',
            async: true,
            success: function(data) {
                jQuery( '.js_checkout_confirmation_button' ).removeClass('disabled').prop("disabled", false);
                jQuery( '.warning_msg' ).remove();
                if(data.reload === true){
                    go_navigate( '', window.location.href );
                }else{
                    jQuery('.js_update_order_total').html(data.order_total);
                    jQuery('.js_update_coupon_block').html(data.coupon_block_content);
                    jQuery('.js_payment_options').html(data.payment_options);
                }

            }
        });
    }
}

// ----------------------------

// Show cuurency modal (switch)
function change_currency( e, trigger, bool ) {
    let currency = trigger.attr( 'data-currency-value' );

    if ( bool === 'true' && cart_check_contents > 0 ) {
        Swal.fire({
            icon: 'warning',
            title: GLOB_ATTENTION,
            html: TEXT_CHANGE_CURRENCY_POPUP,
            showDenyButton: true,
            confirmButtonText: BTN_CONTINUE,
            denyButtonText: BTN_CANCEL,
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                change_currency_ajax( currency );
            } else {
                return false;
            }
        })
    } else {
        change_currency_ajax( currency );
    }
}

function change_currency_ajax( arg ) {
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_currency: arg,
            ajax_action: 'general_settings',
            function: 'change_currency'
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            location.reload();
        },
        complete: function( data ) { },
        error: function() {
            console.log('Something went wong... Hai!');
        }
    });
}

// ----------------------------

// Create account

// Toggle B2B / B2C
function toggle_account_type( event, elem ) {
    let _this               = elem;
    let this_type           = _this.attr( 'data-ref' );
    let account_type_button = jQuery( '.toggle_account_type' );

    let b2b_element                 = jQuery( '.js_b2b_element');
    let b2b_input_element           = jQuery( '.js_b2b_element input , .js_b2b_element select');
    let b2c_element                 = jQuery( '.js_b2c_element');
    let b2c_input_element           = jQuery( '.js_b2c_element input , .js_b2c_element select');

    // Remove active class from button
    account_type_button.removeClass( 'active' );
    // // Set active class for button
    _this.addClass( 'active' );

    //toggle b2b elements
    if (this_type == 'b2b') {
        b2c_element.removeClass( 'active' );
        b2b_element.addClass( 'active' );
        b2c_input_element.prop("disabled", true);
        b2b_input_element.prop("disabled", false);
    } else {
        b2c_element.addClass( 'active' );
        b2b_element.removeClass( 'active' );
        b2b_input_element.prop("disabled", true);
        b2c_input_element.prop("disabled", false);
    }

}

// ----------------------------

// Create account B2B

// Country required depending on selected country and store country
function check_country_required( selected_country ) {
    let target_input = jQuery('.upload_vat_number');
    let target_input_parent = target_input.parent();
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            selected_country: selected_country,
            ajax_action: 'general_settings',
            function: 'country_input_required'
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            target_input_parent.removeClass('required');
            target_input.removeClass('js_required');
            if(data !== '') {
                target_input_parent.addClass(data);
                target_input.addClass('js_' + data);
            }
        }
    });
}

// ----------------------------
// notification center

function toggle_notification_setting(elem){
    let checkbox_value = elem.is(":checked");
    let notification_type = elem.attr( 'data-type' );
    let html_confirm_message = elem.attr( 'data-activate-mssg' );
    if(!checkbox_value){
        html_confirm_message = elem.attr( 'data-deactivate-mssg' );
    }

    Swal.fire({
        icon: 'warning',
        title: GLOB_ATTENTION,
        html: html_confirm_message,
        showDenyButton: true,
        confirmButtonText: BTN_CONTINUE,
        denyButtonText: BTN_CANCEL,
        showCloseButton: true,
    }).then((result) => {
        if (result.isConfirmed) {
            jQuery.ajax({
                type: 'POST',
                url: ajax_url_global + Math.random(),
                data: {
                    type: notification_type,
                    value: checkbox_value,
                    ajax_action: 'notification_center',
                    function: 'change_setting'
                },
                async: true,
                dataType: 'json',
                success: function( data ) {
                    do_toast( GLOB_SUCCESS, data.success_msg, 'success', 3000, '', true );
                    if(checkbox_value){
                        elem.prop('checked', true);
                    }else{
                        elem.prop('checked', false);
                    }
                    wait( 3000 ).then( function() {
                        location.reload();
                    });
                },
                complete: function( data ) {
                },
                error: function() {
                    console.log('Something went wong... Hai!');
                }
            });
        } else {
            return false;
        }
    })
}

// ----------------------------

function change_product_by_attribute(elem){
    let ref_product = elem.attr( 'data-product-ref' );
    if(ref_product.length > 2){
        go_navigate( '', ref_product );
    }
}

function trigger_attribute_filter(){
    jQuery( '.js_remove_all_variant_filters' ).show();
    let trigger_element = jQuery( 'select.select_variant:first' );
    let val = trigger_element.val();
    trigger_element.val( val ).change();
}
// ----------------------------

//action countdown

function get_action_countdown(){
    let countdown_days    = jQuery( '.js_days' );
    let countdown_hours   = jQuery( '.js_hours' );
    let countdown_minutes = jQuery( '.js_minutes' );
    let countdown_seconds = jQuery( '.js_seconds' );
    let action_countdown = jQuery( '.js_counter' ).attr( 'data-ref' );

    let end = new Date(action_countdown);

    let _second = 1000;
    let _minute = _second * 60;
    let _hour = _minute * 60;
    let _day = _hour * 24;
    let timer;

    function showRemaining() {
        if (action_countdown !== '') {
            let now = new Date();
            let distance = end - now;
            if (distance < 0) {

                clearInterval(timer);
                return;
            }
            let days = Math.floor(distance / _day);
            let hours = Math.floor((distance % _day) / _hour);
            let minutes = Math.floor((distance % _hour) / _minute);
            let seconds = Math.floor((distance % _minute) / _second);

            countdown_days.text(days);
            countdown_hours.text(hours);
            countdown_minutes.text(minutes);
            countdown_seconds.text(seconds);
        }
    }
    timer = setInterval(showRemaining, 1);

}

// Show / hide login modal
function login_popup() {
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_action: 'general_settings',
            function: 'login_modal'
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            let login_modal = jQuery( '.js_login_modal' );
            if ( login_modal.length ) {
                login_modal.html(data.login_modal);
                login_modal.addClass( 'active' );
            }
        },
        complete: function() { },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

function close_login_modal(  ) {
    let login_modal = jQuery( '.js_login_modal' );
    if ( login_modal.length ) {
        login_modal.removeClass( 'active' );
        login_modal.html('');
    }
}

// checks selected items in a set if total amounts match the set settings
function check_package_selected_items_amount(selector, init){
    let set_code = selector.data( 'component-code' );
    let total_selected_amount = count_package_group_items(set_code);
    if(total_selected_amount > parseInt(selector.data( 'component-max-amount' ))){
        selector.val(selector.data( 'component-reset-amount' )).trigger('change');
        total_selected_amount = count_package_group_items(set_code);
        do_toast( GLOB_ATTENTION, selector.data( 'error-msg' ), 'error', 600000, '', true, 'modal_clone', true, BTN_CONTINUE );
    }

    jQuery( '.js_component_code_' + set_code ).html(jQuery( '.js_component_code_' + set_code ).data('component-counter').replace(/0/, total_selected_amount));
    update_package_price(init);
}

function count_package_group_items(set_code){
    let total_selected_amount = 0;
    jQuery('select.js_select_component_amount[data-component-code="' + set_code + '"]').each(function () {
        total_selected_amount = parseInt(total_selected_amount) + parseInt(jQuery( this ).val());
    });
    return total_selected_amount;
}

function update_package_price(init){
    let price = 0;
    jQuery('.js_select_component_amount').each(function () {
        price = parseFloat(price) + (parseFloat(jQuery( this ).data( 'component-price' )) * jQuery( this ).val());
    });
    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_action: 'general_settings',
            function: 'format_price',
            decimal_price: price
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            jQuery('.price_from').html('');
            jQuery('.price_main').html(data.price + ' / ' + jQuery('.price_main').data( 'unit-text' ));
        },
        complete: function() { },
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}

function init_configurable_set_text(){
    jQuery('.js_select_component_amount').each(function () {
        let set_code = jQuery( this ).data( 'component-code' );
        let total_selected_amount = count_package_group_items(set_code);
        jQuery( '.js_component_code_' + set_code ).html(jQuery( '.js_component_code_' + set_code ).data('component-counter').replace(/0/, total_selected_amount));
    });
}

function  validate_configurable_set(){
    let valid_set = true;
    jQuery('.js_component_settings ').each(function() {
        let total_selected_amount = count_package_group_items(jQuery(this).data( 'component-code' ));
        jQuery( '.js_select_component_amount[data-component-code="' + jQuery(this).data( 'component-code' ) + '"]' ).parent().find( '.select2-container' ).removeClass( 'error_msg' );
        if(total_selected_amount < parseInt(jQuery(this).data( 'component-min-amount' )) || total_selected_amount > parseInt(jQuery(this).data( 'component-max-amount' ))){
            jQuery( '.js_select_component_amount[data-component-code="' + jQuery(this).data( 'component-code' ) + '"]' ).parent().find( '.select2-container' ).addClass( 'error_msg' );
            valid_set = false;
        }
    });
    return valid_set;
}

// ----------------------------
// LEGACY? Is it being used?

/*
// Send data for reorder - watch list?
function reorder( array_data, target, total_amount ) {
    let ajax_action_req		= 'shopping_cart';
    let ajax_function_req	= 'add_order';

    if ( body_class( 'is_account_watch_list_details' ) ) {
        ajax_action_req		= 'shopping_list';
        ajax_function_req	= 'add_list_to_cart';
    }

    jQuery.ajax({
        type: 'POST',
        url: ajax_url_global + Math.random(),
        data: {
            ajax_action: ajax_action_req,
            function: ajax_function_req,
            order_content: JSON.stringify( array_data )
        },
        async: true,
        dataType: 'json',
        success: function( data ) {
            if ( ! total_amount || total_amount == 0 ) {
                // Notify user <-- No items selected
                let title	= GLOB_ATTENTION;
                let mssg	= no_products_selected;

                message( 'warning', title, mssg, 'close_message(); ' + close_mask + '', '', true );
            } else {
                do_stuff( '', '', '', '', 'init_both' );

                // Reset input fields / remove classes
                jQuery( '.stock_list .buy_amount' ).removeClass( 'valid_amount' ).find( 'input' ).val( 0 );
            }
        },
        complete: function() {},
        error: function() {
            console.log( 'Something went wong... Hai!' );
        }
    });
}
*/
